// import { useCallback, useEffect, useMemo, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
// } from "@mui/material";
// import {
//   Pencil,
//   Plus,
//   RotateCcw,
//   Trash2,
//   X,
// } from "lucide-react";
// import { toast } from "react-toastify";

// import { fmtMoney } from "../../utils/payrollFormat";
// import { toIsoDate } from "../../utils/dateFormat";
// import { StatusPill } from "../Table/Table";
// import IsoDateInput from "../common/Isodateinput";

// /* ────────────────────────────────────────────────────────────────────────── */
// /* Constants                                                                  */
// /* ────────────────────────────────────────────────────────────────────────── */

// const INITIAL_SALARY_FORM = {
//   employeeId: "",
//   salaryReference: "",
//   basic: "",
//   effectiveDate: "",
//   endDate: "",
//   payFrequency: "M",
//   grossSalary: 0,
//   workingDays: null,
//   dailyRate: "",
//   isCurrent: true,
//   isActive: true,
//   remarks: "",
// };

// const INITIAL_COMPONENT_FORM = {
//   componentId: "",
//   amount: "",
//   percentage: 0,
//   effectiveDate: "",
//   endDate: "",
//   isActive: true,
//   remarks: "",
// };

// const PAY_FREQUENCIES = [
//   {
//     value: "M",
//     label: "Monthly",
//   },
//   {
//     value: "W",
//     label: "Weekly",
//   },
// ];

// const getOneYearFromToday = (date) => {
//   const d = new Date(date);
//   d.setFullYear(d.getFullYear() + 1);
//   return d;
// }

// const getLastDayOfThisMonth = (date) => {
//   const d = new Date(date);
//   return new Date(d.getFullYear(), d.getMonth() + 1, 0);
// }

// const maskCurrencyInput = (rawValue) => {
//   const digits = String(rawValue ?? "").replace(/\D/g, "");

//   if (!digits) return "";

//   const padded = digits.padStart(3, "0");
//   const cents = padded.slice(-2);

//   const wholeDigits = padded.slice(0, -2).replace(/^0+(?=\d)/, "");
//   const whole = Number(wholeDigits || "0").toLocaleString("en-US");

//   return `${whole}.${cents}`;
// }

// const parseCurrency = (value) => {
//   if (value === "" || value === null) return 0;
//   const n = Number(String(value).replace(/,/g, ""));
//   return Number.isNaN(n) ? 0 : n;
// }

// /* ────────────────────────────────────────────────────────────────────────── */
// /* Styles                                                                     */
// /* ────────────────────────────────────────────────────────────────────────── */

// const INPUT_CLASS = `
//   w-full h-10
//   rounded-md
//   border border-surface-200
//   bg-white
//   px-3
//   text-sm text-surface-800
//   outline-none
//   transition-colors
//   focus:border-primary-500
//   focus:ring-1 focus:ring-primary-500
// `;

// const DISABLED_INPUT_CLASS = `
//   !bg-gray-100
//   !text-gray-500
//   !border-gray-300
//   cursor-not-allowed
// `;

// const LABEL_CLASS = `
//   absolute
//   left-2.5
//   top-0
//   -translate-y-1/2
//   bg-white
//   px-1
//   text-[11px]
//   text-surface-500
//   pointer-events-none
//   z-10
// `;

// const SECTION_TITLE_CLASS = `
//   text-sm
//   font-semibold
//   text-surface-900
// `;

// const SECTION_SUBTITLE_CLASS = `
//   mt-0.5
//   text-xs
//   text-surface-500
// `;

// /* ────────────────────────────────────────────────────────────────────────── */
// /* Small Form Components                                                      */
// /* ────────────────────────────────────────────────────────────────────────── */

// function Field({ label, children, className = "", error = "", }) {
//   return (
//     <div className={`relative ${className}`}>
//       <label className={LABEL_CLASS}>
//         {label}
//       </label>

//       {children}

//       {error && (
//         <p className="mt-1.5 flex items-start gap-1 text-xs text-red-600">
//           {error}
//         </p>
//       )}
//     </div>
//   );
// }

// function TextInput({
//   label,
//   value,
//   onChange,
//   type = "text",
//   disabled = false,
//   placeholder = "",
//   min,
//   step,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <input
//         type={type}
//         value={value ?? ""}
//         onChange={onChange}
//         disabled={disabled}
//         placeholder={placeholder}
//         min={min}
//         step={step}
//         className={`${INPUT_CLASS} ${
//           disabled ? DISABLED_INPUT_CLASS : ""
//         } ${
//             error ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500" : ""
//         }`}
//       />
//     </Field>
//   );
// }

// function CurrencyInput({
//   label,
//   value,
//   onChange,
//   disabled = false,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <input
//         type="text"
//         inputMode="decimal"
//         value={value ?? ""}
//         disabled={disabled}
//         onChange={(event) =>
//           onChange(maskCurrencyInput(event.target.value))
//         }
//         className={`${INPUT_CLASS} ${
//           disabled ? DISABLED_INPUT_CLASS : ""
//         } ${
//           error
//             ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500"
//             : ""
//         }`}
//       />
//     </Field>
//   )
// }

// function DateInput({
//   label,
//   value,
//   onChange,
//   disabled = false,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <IsoDateInput
//         value={value ?? ""}
//         onChange={onChange}
//         disabled={disabled}
//         className={`${INPUT_CLASS} appearance-none ${
//           disabled ? DISABLED_INPUT_CLASS : ""
//         } ${
//             error ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500" : ""
//         }`}
//       />
//     </Field>
//   );
// }

// function SelectInput({
//   label,
//   value,
//   onChange,
//   children,
//   disabled = false,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <select
//         value={value ?? ""}
//         onChange={onChange}
//         disabled={disabled}
//         className={`${INPUT_CLASS} appearance-auto cursor-pointer ${
//           disabled ? DISABLED_INPUT_CLASS : ""
//         } ${
//             error ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500" : ""
//         }`}
//       >
//         {children}
//       </select>
//     </Field>
//   );
// }

// function TextArea({
//   label,
//   value,
//   onChange,
//   disabled = false,
//   rows = 2,
//   error = "",
//   className = "",
// }) {
//   return (
//     <Field label={label} error={error} className={className}>
//       <textarea
//         value={value ?? ""}
//         onChange={onChange}
//         disabled={disabled}
//         rows={rows}
//         className={`
//           w-full
//           rounded-md
//           border border-surface-200
//           bg-white
//           px-3
//           py-2.5
//           text-sm
//           text-surface-800
//           outline-none
//           transition-colors
//           focus:border-primary-500
//           focus:ring-1
//           focus:ring-primary-500
//           resize-none
//           ${disabled ? DISABLED_INPUT_CLASS : ""}
//           ${error ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500" : ""}
//         `}
//       />
//     </Field>
//   );
// }

// function CheckboxInput({
//   label,
//   checked,
//   onChange,
//   disabled = false,
// }) {
//   return (
//     <label
//       className={`
//         flex
//         items-center
//         gap-2
//         text-sm
//         text-surface-700
//         ${disabled ? "cursor-not-allowed text-gray-500" : "cursor-pointer"}
//       `}
//     >
//       <input
//         type="checkbox"
//         checked={Boolean(checked)}
//         onChange={onChange}
//         disabled={disabled}
//         className="
//           h-4
//           w-4
//           rounded
//           border-surface-300
//           accent-primary-600
//         "
//       />

//       {label}
//     </label>
//   );
// }

// /* ────────────────────────────────────────────────────────────────────────── */
// /* Main Component                                                             */
// /* ────────────────────────────────────────────────────────────────────────── */

// const EmployeeSalaryDialog = ({
//   open,
//   onClose,
//   onSave,
//   onSaveComponent,
//   onExited,

//   employees = [],
//   employeeSalaries = [],
//   salary = null,
//   mode = "add",

//   salaryComponents = [],
//   payrollComponents = [],
// }) => {
//   const isAdd = mode === "add";
//   const isEdit = mode === "edit";
//   const isView = mode === "view";

//   const [salaryForm, setSalaryForm] = useState(INITIAL_SALARY_FORM);
//   const [componentForm, setComponentForm] = useState(INITIAL_COMPONENT_FORM);
//   const [showComponentForm, setShowComponentForm] = useState(false);
//   const [pendingComponents, setPendingComponents] = useState([]);
//   const [editingComponentId, setEditingComponentId] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [componentErrors, setComponentErrors] = useState({});
//   const [salaryReferenceAuto, setSalaryReferenceAuto] = useState(true);

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Initialize Salary Form                                                  */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   useEffect(() => {
//     if (!open) {
//       return;
//     }

//     setErrors({});
//     setShowComponentForm(false);
//     setComponentForm(INITIAL_COMPONENT_FORM);
//     setPendingComponents([]);
//     setEditingComponentId(null);
//     setComponentErrors({});
//     setSalaryReferenceAuto(true);

//     if (salary && (isEdit || isView)) {
//       setSalaryForm({
//         employeeId: salary.employeeId ?? "",
//         salaryReference: salary.salaryReference ?? "",
//         effectiveDate:
//           toIsoDate(salary.effectiveDate) ?? "",
//         endDate:
//           toIsoDate(salary.endDate) ?? "",
//         payFrequency:
//           salary.payFrequency === "Monthly"
//             ? "M"
//             : salary.payFrequency === "Weekly"
//               ? "W"
//               : salary.payFrequency ?? "M",
//         grossSalary: salary.grossSalary ?? "",
//         workingDays: salary.workingDays ?? "",
//         basic: salary.basic !== null ? maskCurrencyInput(String(Math.round(Number(salary.basic) * 100))) : "",
//         dailyRate: salary.dailyRate !== null ? maskCurrencyInput(String(Math.round(Number(salary.dailyRate) * 100))) : "",
//         isCurrent: salary.isCurrent ?? true,
//         isActive: salary.isActive ?? true,
//         remarks: salary.remarks ?? "",
//       });

//       return;
//     }

//     const today = new Date();

//     setSalaryForm({
//       ...INITIAL_SALARY_FORM,
//       effectiveDate: toIsoDate(today),
//       endDate: toIsoDate(getOneYearFromToday(today)),
//     });

//     setSalaryReferenceAuto(true);
//   }, [
//     open,
//     salary,
//     isEdit,
//     isView,
//   ]);

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Components belonging to current salary                                  */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const currentSalaryComponents = useMemo(() => {
//     if (!salary?.id) {
//       return [];
//     }

//     return salaryComponents
//       .filter(
//         (component) =>
//           String(component.employeeSalaryId) ===
//           String(salary.id)
//       )
//       .map((component) => ({
//         ...component,
//         componentName:
//           payrollComponents.find(
//             (payrollComponent) =>
//               String(payrollComponent.id) ===
//               String(component.componentId)
//           )?.name ??
//           component.remarks ??
//           "-",
//       }));
//   }, [
//     salary,
//     salaryComponents,
//     payrollComponents,
//   ]);

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Employee Assigned Check                                                  */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const isEmployeeAssigned = useCallback((employeeId) => {
//     // Do not perform the period check until both dates are entered
//     if (!salaryForm.effectiveDate || !salaryForm.endDate) {
//       return false;
//     }

//     const newStart = new Date(salaryForm.effectiveDate);
//     const newEnd = new Date(salaryForm.endDate);

//     return employeeSalaries.some((salaryRecord) => {
//         // Don't compare the salary against itself while editing
//         if (
//           isEdit &&
//           String(salaryRecord.id) === String(salary?.id)
//         ) {
//           return false;
//         }

//         // Only check salary records belonging to this employee
//         if (String(salaryRecord.employeeId) !== String(employeeId)) {
//             return false;
//         }

//         // Ignore records without a complete effective period
//         if (!salaryRecord.effectiveDate || !salaryRecord.endDate) {
//             return false;
//         }

//         const existingStart = new Date(salaryRecord.effectiveDate);
//         const existingEnd = new Date(salaryRecord.endDate);

//         // Check for period overlap
//         return (newStart <= existingEnd && newEnd >= existingStart);
//       }
//     );
//   }, [
//     salaryForm.effectiveDate,
//     salaryForm.endDate,
//     employeeSalaries,
//     isEdit,
//     salary?.id
//   ]);

//   const generateSalaryReference = (employee, existingRefs = []) => {
//     if (!employee) return "";
//     const base = `SAL-${employee.HED_SERVICE_NO}-${Date.now().toString().slice(-5)}`;
//     let candidate = base;
//     let suffix = 1;
//     while (existingRefs.includes(candidate)) {
//       candidate = `${base}-${suffix++}`;
//     }
//     return candidate;
//   }

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Form Changes                                                             */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const handleSalaryChange = (key, value) => {
//     if (isView) {
//       return;
//     }

//     let salaryReference;

//     if (key === "employeeId" && isAdd && salaryReferenceAuto) {
//       const employee = employees.find((e) => String(e.HED_EMPLOYEE_ID) === String(value));
//       const existingRefs = employeeSalaries.map((s) => s.salaryReference);

//       salaryReference = generateSalaryReference(employee, existingRefs);
//     }

//     if (key === "salaryReference") {
//       setSalaryReferenceAuto(false);
//     }

//     setSalaryForm((previous) => ({
//       ...previous,
//       [key]: value,

//       ...(salaryReference !== undefined ? { salaryReference } : {}),

//       ...(key === "payFrequency" && value === "W" ? { basic: "" } : {}),
//     }));

//     setErrors((prev) => {
//         if (!prev[key]) {
//             return prev;
//         }

//         const next = { ...prev };
//         delete next[key];

//         if (key === "payFrequency" && value === "W") {
//           delete next.basic;
//         }

//         return next;
//     })
//   };

//   const handleComponentChange = (key, value) => {
//     if (isView) {
//       return;
//     }

//     setComponentForm((previous) => ({
//       ...previous,
//       [key]: value,
//     }));

//     // Clear field error when user starts changing it
//     setComponentErrors((prev) => {
//       if (!prev[key]) return prev;
//       const next = { ...prev };
//       delete next[key];
//       return next;
//     })
//   };

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Component Form                                                           */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const resetComponentForm = () => {
//     setComponentForm(INITIAL_COMPONENT_FORM);
//     setEditingComponentId(null);
//     setShowComponentForm(false);
//     setComponentErrors({});
//   };

//   const handleEditExistingComponent = (component) => {
//     if (isView) return;

//     setEditingComponentId(component.id);

//     setComponentForm({
//       employeeSalaryComponentId: component.employeeSalaryComponentId ?? component.id,
//       componentId: component.componentId ?? "",
//       amount: component.amount != null
//         ? maskCurrencyInput(String(Math.round(Number(component.amount) * 100)))
//         : component.componentAmount != null ? maskCurrencyInput(String(Math.round(Number(component.componentAmount) * 100)))
//         : "",
//       percentage: component.percentage ?? component.componentPercentage ?? 0,
//       effectiveDate: toIsoDate(component.effectiveDate) ?? "",
//       endDate: toIsoDate(component.endDate) ?? "",
//       isActive: component.isActive ?? true,
//       remarks: component.remarks ?? "",
//     });

//     setShowComponentForm(true);
//   }

//   const handleAddPendingComponent = () => {
//     const validationErrors = {};

//     if (!componentForm.componentId) {
//       validationErrors.componentId = "Please select a salary component.";
//     }

//     if (
//       componentForm.amount === "" ||
//       parseCurrency(componentForm.amount) < 0
//     ) {
//       validationErrors.amount = "Please enter a valid amount.";
//     }

//     if (!componentForm.effectiveDate) {
//       validationErrors.effectiveDate = "Please select the component effective start date.";
//     }

//     if (!componentForm.endDate) {
//       validationErrors.endDate = "Please select the component end date.";
//     }

//     if (
//       new Date(componentForm.effectiveDate) >
//       new Date(componentForm.endDate)
//     ) {
//       validationErrors.endDate = "Component end date cannot be before the effective date.";
//     }

//     const duplicate = pendingComponents.some(
//       (component) =>
//         String(component.componentId) ===
//         String(componentForm.componentId)
//     );

//     if (duplicate) {
//       validationErrors.componentId = "This salary component has already been added.";
//     }

//     if (Object.keys(validationErrors).length > 0) {
//       setComponentErrors(validationErrors);
//       return;
//     }

//     setPendingComponents((previous) => [
//       ...previous,
//       {
//         ...componentForm,
//         amount:
//           componentForm.amount === ""
//             ? 0
//             : parseCurrency(componentForm.amount),
//         percentage:
//           Number(componentForm.percentage || 0),
//         isActive: true,
//       },
//     ]);

//     resetComponentForm();
//   };

//   const handleUpdateExistingComponent = async () => {
//     if (!editingComponentId) return;

//     const validationErrors = {};

//     if (!componentForm.componentId) {
//       validationErrors.componentId = "Please select a salary component.";
//     }

//     if (componentForm.amount === "" || parseCurrency(componentForm.amount) < 0) {
//       validationErrors.amount = "Please enter a valid amount."
//     }

//     if (!componentForm.effectiveDate) {
//       validationErrors.effectiveDate = "Please select the component effective start date."
//     }

//     if (!componentForm.endDate) {
//       validationErrors.endDate = "Please select the component effective end date."
//     }

//     if (
//       new Date(componentForm.effectiveDate) >
//       new Date(componentForm.endDate)
//     ) {
//       validationErrors.endDate =
//         "Component end date cannot be before the effective date.";
//     }

//     if (Object.keys(validationErrors).length > 0) {
//       setComponentErrors(validationErrors);
//       return;
//     }

//     setSaving(true);

//     try {
//       await onSaveComponent(
//         {
//           employeeSalaryComponentId: componentForm.employeeSalaryComponentId ?? editingComponentId,
//           employeeSalaryId: salary?.id,
//           componentId: componentForm.componentId,
//           componentAmount: parseCurrency(componentForm.amount),
//           componentPercentage: Number(componentForm.percentage || 0),
//           effectiveDate: componentForm.effectiveDate,
//           endDate: componentForm.endDate,
//           isActive: componentForm.isActive !== false,
//           remarks: componentForm.remarks ?? "",
//         },
//         true
//       );

//       resetComponentForm();
//     } catch (error) {
//       console.error("Failed to update salary component: ", error);
//     } finally {
//       setSaving(false);
//     }
//   }

//   const handleToggleExistingComponentStatus = async (component, newActiveState) => {
//     const componentId = component.employeeSalaryComponentId ?? component.id;
//     setSaving(true);

//     try {
//       await onSaveComponent({
//         employeeSalaryComponentId: componentId,
//         employeeSalaryId: salary?.id,
//         componentId: component.componentId,
//         componentAmount: parseCurrency(component.amount ?? component.componentAmount ?? 0),
//         componentPercentage: Number(component.percentage ?? component.componentPercentage ?? 0),
//         effectiveDate: component.effectiveDate,
//         endDate: component.endDate,
//         isActive: newActiveState,
//         remarks: component.remarks ?? "",
//       },
//       true);
//     } catch (error) {
//       console.error(`Failed to ${newActiveState ? "reactivate" : "remove"} salary component: `, error);
//     } finally {
//       setSaving(false);
//     }
//   }

//   const handleRemovePendingComponent = (index) => {
//     setPendingComponents((previous) =>
//       previous.filter((_, itemIndex) => itemIndex !== index)
//     );
//   };

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Save and Validation                                                      */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const handleSave = async () => {
//     if (isView) {
//       onClose?.();
//       return;
//     }

//     const validationErrors = {};

//     if (!salaryForm.employeeId) {
//         validationErrors.employeeId = "Please select an employee.";
//     } else if (isAdd && isEmployeeAssigned(salaryForm.employeeId)) {
//         validationErrors.employeeId = "This employee already has a salary assigned for this effective period.";
//     }

//     if (!String(salaryForm.salaryReference).trim()) {
//         validationErrors.salaryReference = "Salary reference is required.";
//     }

//     const duplicateRef = employeeSalaries.some(
//       (s) => String(s.salaryReference ?? "").trim().toLowerCase() === String(salaryForm.salaryReference ?? "").trim().toLowerCase() &&
//       !(isEdit && String(s.id) === String(salary?.id))
//     );

//     if (duplicateRef) {
//       validationErrors.salaryReference = "This salary reference is already in use.";
//     }

//     if (salaryForm.payFrequency !== "W") {
//       if (!salaryForm.basic) {
//         validationErrors.basic =
//           "Please enter a basic salary.";
//       } else if (parseCurrency(salaryForm.basic) < 0) {
//         validationErrors.basic =
//           "Basic salary must be positive.";
//       }
//     }

//     if (!salaryForm.effectiveDate) {
//         validationErrors.effectiveDate = "Please select an effective start date.";
//     }

//     if (!salaryForm.endDate) {
//         validationErrors.endDate = "Please select an effective end date.";
//     }

//     if (salaryForm.effectiveDate && salaryForm.endDate && new Date(salaryForm.effectiveDate) > new Date(salaryForm.endDate)) {
//         validationErrors.endDate = "End date cannot be before the starting date.";
//     }

//     if (salaryForm.workingDays !== "" && Number(salaryForm.workingDays) < 0) {
//         validationErrors.workingDays = "Working days cannot be negative.";
//     }

//     if (salaryForm.dailyRate !== "" && parseCurrency(salaryForm.dailyRate) < 0) {
//         validationErrors.dailyRate = "Daily rate cannot be negative.";
//     }

//     setErrors(validationErrors);

//     // Stop if validation failed
//     if (Object.keys(validationErrors).length > 0) {
//         // toast.error(Object.values(validationErrors)[0]);
//         return;
//     }

//     setSaving(true);

//     try {
//       const salaryPayload = {
//         ...salaryForm,

//         ...(isEdit && {
//           id: salary?.id,
//         }),

//         basic: salaryForm.payFrequency === "W" ? 0 : parseCurrency(salaryForm.basic),

//         grossSalary: Number(salaryForm.grossSalary || 0),

//         workingDays:
//           salaryForm.workingDays === ""
//             ? undefined
//             : Number(salaryForm.workingDays || 0),

//         dailyRate:
//           salaryForm.dailyRate === ""
//             ? undefined
//             : parseCurrency(salaryForm.dailyRate),
//       };

//       /*
//        * The parent is responsible for saving the employee salary.
//        *
//        * onSave should ideally return the saved salary record:
//        *
//        * {
//        *   id: 123,
//        *   ...
//        * }
//        *
//        * This allows the parent to save pending components
//        * using the newly-created employeeSalaryId.
//        */
//       await onSave?.(
//         salaryPayload,
//         pendingComponents
//       );

//       setPendingComponents([]);
//       setComponentForm(INITIAL_COMPONENT_FORM);
//       setShowComponentForm(false);
//     } catch (error) {
//       console.error(
//         "Failed to save employee salary:",
//         error
//       );

//       toast.error(
//         "Failed to save employee salary."
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Employee Name                                                            */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const selectedEmployee = useMemo(() => {
//     return employees.find(
//       (employee) =>
//         String(employee.HED_EMPLOYEE_ID) ===
//         String(salaryForm.employeeId)
//     );
//   }, [
//     employees,
//     salaryForm.employeeId,
//   ]);

//   // Previous salary lookuup
//   const previousSalaries = useMemo(() => {
//     if (!salaryForm.employeeId) return [];

//     const empSalaries = employeeSalaries.filter(
//       (s) =>
//         String(s.employeeId) === String(salaryForm.employeeId) &&
//         String(s.id) !== String(salary?.id) // exclude the one currently being edited
//     );

//     // Sort descending by effective date so the most recent past salaries are at the top
//     return empSalaries.sort(
//       (a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate)
//     );
//   }, [salaryForm.employeeId, employeeSalaries, salary?.id]);

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Title                                                                    */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const title = isAdd
//     ? "Assign Employee Salary"
//     : isEdit
//       ? "Update Employee Salary"
//       : "Employee Salary Details";

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Render                                                                   */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   return (
//     <Dialog
//       open={open}
//       onClose={saving ? undefined : onClose}
//       maxWidth="md"
//       fullWidth
//       TransitionProps={{
//         onExited: () => {
//           setSalaryForm(INITIAL_SALARY_FORM);
//           setComponentForm(INITIAL_COMPONENT_FORM);
//           setPendingComponents([]);
//           setShowComponentForm(false);
//           setErrors({});
//           setComponentErrors({});
//           setSaving(false);
//           setSalaryReferenceAuto(true);
//           onExited?.();
//         },
//       }}
//     >
//       {/* ──────────────────────────────────────────────────────────────── */}
//       {/* Header                                                          */}
//       {/* ──────────────────────────────────────────────────────────────── */}

//       <DialogTitle className="!px-6 !pt-5 !pb-3">
//         <div className="flex items-center justify-between gap-4">
//           <div>
//             <h2 className="text-lg font-semibold text-surface-900">
//               {title}
//             </h2>

//             {selectedEmployee && (
//               <p className="mt-0.5 text-xs text-surface-500">
//                 {selectedEmployee.HED_SERVICE_NO}{" "}
//                 -{" "}
//                 {selectedEmployee.HED_REPORT_NAME}
//               </p>
//             )}
//           </div>
//         </div>
//       </DialogTitle>

//       <DialogContent className="!px-6 !py-4">
//         <div className="space-y-6">

//           {/* ────────────────────────────────────────────────────────── */}
//           {/* Employee Salary Details                                   */}
//           {/* ────────────────────────────────────────────────────────── */}

//           <section>
//             <div className="mb-5">
//               <h3 className={SECTION_TITLE_CLASS}>
//                 Employee Salary Details
//               </h3>

//               <p className={SECTION_SUBTITLE_CLASS}>
//                 Configure the employee's salary and effective period.
//               </p>
//             </div>

//             <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">

//               {/* Employee */}
//               <SelectInput
//                 label="Employee"
//                 value={salaryForm.employeeId}
//                 disabled={!isAdd || isView}
//                 error={errors.employeeId}
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "employeeId",
//                     event.target.value
//                   )
//                 }
//               >
//                 <option value="">
//                   Select Employee
//                 </option>

//                 {employees.map((employee) => (
//                     <option
//                       key={employee.HED_EMPLOYEE_ID}
//                       value={employee.HED_EMPLOYEE_ID}
//                     >
//                       {employee.HED_SERVICE_NO} -{" "}
//                       {employee.HED_REPORT_NAME}
//                     </option>
//                   ))}
//               </SelectInput>

//               {/* Pay Frequency */}
//               <SelectInput
//                 label="Pay Frequency"
//                 value={salaryForm.payFrequency}
//                 error={errors.payFrequency}
//                 disabled={isView}
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "payFrequency",
//                     event.target.value
//                   )
//                 }
//               >
//                 {PAY_FREQUENCIES.map(
//                   (frequency) => (
//                     <option
//                       key={frequency.value}
//                       value={frequency.value}
//                     >
//                       {frequency.label}
//                     </option>
//                   )
//                 )}
//               </SelectInput>

//               {salaryForm.payFrequency !== "W" && (
//                 // <TextInput
//                 //   label="Basic Salary"
//                 //   value={isView ? fmtMoney(salaryForm.basic) : salaryForm.basic}
//                 //   error={errors.basic}
//                 //   disabled={isView}
//                 //   onChange={(event) =>
//                 //     handleSalaryChange(
//                 //       "basic",
//                 //       event.target.value
//                 //     )
//                 //   }
//                 // />
//                 <CurrencyInput
//                   label="Basic Salary"
//                   value={salaryForm.basic}
//                   error={errors.basic}
//                   disabled={isView}
//                   onChange={(value) =>
//                     handleSalaryChange("basic", value)
//                   }
//                 />
//               )}

//               {/* Salary Reference */}
//               <TextInput
//                 label="Salary Reference"
//                 value={salaryForm.salaryReference}
//                 error={errors.salaryReference}
//                 disabled
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "salaryReference",
//                     event.target.value
//                   )
//                 }
//               />

//               {/* Gross Salary */}
//               {/* <TextInput
//                 label="Gross Salary"
//                 type="number"
//                 min="0"
//                 step="0.01"
//                 value={salaryForm.grossSalary}
//                 disabled={isView}
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "grossSalary",
//                     event.target.value
//                   )
//                 }
//               /> */}

//               {/* Effective Date */}
//               <DateInput
//                 label="Effective Start Date"
//                 value={salaryForm.effectiveDate}
//                 error={errors.effectiveDate}
//                 disabled={isView}
//                 onChange={(value) =>
//                   handleSalaryChange(
//                     "effectiveDate", value
//                     // event.target.value
//                   )
//                 }
//               />

//               {/* End Date */}
//               <DateInput
//                 label="Effective End Date"
//                 value={salaryForm.endDate}
//                 error={errors.endDate}
//                 disabled={isView}
//                 onChange={(value) =>
//                   handleSalaryChange(
//                     "endDate", value
//                     // event.target.value
//                   )
//                 }
//               />

//               {/* Working Days */}
//               {/* <TextInput
//                 label="Working Days"
//                 type="number"
//                 min="0"
//                 step="1"
//                 value={salaryForm.workingDays}
//                 error={errors.workingDays}
//                 disabled={isView}
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "workingDays",
//                     event.target.value
//                   )
//                 }
//               /> */}

//               {/* Daily Rate */}
//               {/* <TextInput
//                 label="Daily Rate"
//                 type="number"
//                 min="0"
//                 step="0.01"
//                 value={isView ? fmtMoney(salaryForm.dailyRate) : salaryForm.dailyRate}
//                 error={errors.dailyRate}
//                 disabled={isView}
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "dailyRate",
//                     event.target.value
//                   )
//                 }
//               /> */}

//               <CurrencyInput
//                 label="Daily Rate"
//                 value={salaryForm.dailyRate}
//                 error={errors.dailyRate}
//                 disabled={isView}
//                 onChange={(value) =>
//                   handleSalaryChange("dailyRate", value)
//                 }
//               />

//               {/* Remarks */}
//               <TextArea
//                 label="Remarks"
//                 value={salaryForm.remarks}
//                 error={errors.remarks}
//                 disabled={isView}
//                 rows={1}
//                 // className="sm:col-span-2"
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "remarks",
//                     event.target.value
//                   )
//                 }
//               />

//               {previousSalaries.length > 0 && (
//                 <div className="sm:col-span-2 mt-2 overflow-hidden rounded-md border border-surface-200">
//                   <div className="bg-surface-50 px-3 py-2 border-b border-surface-200">
//                     <h4 className="text-xs font-semibold text-surface-800">
//                       Previous Salary Records
//                     </h4>
//                   </div>
//                   <div className="overflow-x-auto max-h-48 overflow-y-auto">
//                     <table className="w-full text-left text-xs relative">
//                       <thead className="bg-surface-50/90 sticky top-0 backdrop-blur-sm shadow-sm">
//                         <tr>
//                           <th className="px-3 py-2 font-medium text-surface-600">Basic Salary</th>
//                           <th className="px-3 py-2 font-medium text-surface-600">Effective Period</th>
//                           <th className="px-3 py-2 font-medium text-surface-600">Status</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {previousSalaries.map((prevSalary) => (
//                           <tr key={prevSalary.id} className="border-t border-surface-100">
//                             <td className="px-3 py-2 font-medium text-surface-800">
//                               {fmtMoney(prevSalary.basic)}
//                             </td>
//                             <td className="px-3 py-2 text-surface-600 tabular-nums">
//                               {toIsoDate(prevSalary.effectiveDate)} to {toIsoDate(prevSalary.endDate)}
//                             </td>
//                             <td className="px-3 py-2">
//                               <StatusPill label={prevSalary.status || (prevSalary.isActive ? "Active" : "Inactive")} />
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>
//               )}
//             </div>
//           </section>

//           {/* ────────────────────────────────────────────────────────── */}
//           {/* Salary Components                                         */}
//           {/* ────────────────────────────────────────────────────────── */}

//           <section className="border-t border-surface-200 pt-5">
//             <div className="mb-3 flex items-center justify-between gap-3">
//               <div>
//                 <h3 className={SECTION_TITLE_CLASS}>
//                   Salary Components
//                 </h3>

//                 <p className={SECTION_SUBTITLE_CLASS}>
//                   Add allowances, deductions and other salary components.
//                 </p>
//               </div>

//               {!isView && (
//                 <Button
//                   type="button"
//                   size="small"
//                   variant="outlined"
//                   startIcon={<Plus size={14} />}
//                   onClick={() =>
//                     setShowComponentForm((previous) => {
//                       const opening = !previous;

//                       if (opening && !editingComponentId) {
//                         const today = new Date();

//                         setComponentForm({
//                           ...INITIAL_COMPONENT_FORM,
//                           effectiveDate: toIsoDate(today),
//                           endDate: toIsoDate(getLastDayOfThisMonth(today)),
//                         });
//                       }

//                       return opening;
//                     })
//                   }
//                   className="
//                     !min-w-0
//                     !border-primary-600
//                     !px-3
//                     !py-1.5
//                     !text-primary-600
//                   "
//                 >
//                   Add Component
//                 </Button>
//               )}
//             </div>

//             {/* Existing Components */}
//             {currentSalaryComponents.length === 0 &&
//             pendingComponents.length === 0 ? (
//               <div className="
//                 rounded-md
//                 border
//                 border-dashed
//                 border-surface-300
//                 bg-surface-50
//                 px-4
//                 py-5
//                 text-center
//               ">
//                 <p className="text-xs text-surface-500">
//                   No salary components assigned.
//                 </p>

//                 {!isView && (
//                   <p className="mt-1 text-[11px] text-surface-400">
//                     Click "Add Component" to assign one.
//                   </p>
//                 )}
//               </div>
//             ) : (
//               <div className="overflow-hidden rounded-md border border-surface-200">
//                 <div className="overflow-x-auto">
//                   <table className="w-full min-w-[620px] text-xs">
//                     <thead className="bg-surface-50">
//                       <tr>
//                         <th className="px-3 py-2 text-left font-medium text-surface-600">
//                           Component
//                         </th>

//                         <th className="px-3 py-2 text-right font-medium text-surface-600">
//                           Amount
//                         </th>

//                         <th className="px-3 py-2 text-center font-medium text-surface-600">
//                           Effective
//                         </th>

//                         <th className="px-3 py-2 text-center font-medium text-surface-600">
//                           End
//                         </th>

//                         <th className="px-3 py-2 text-center font-medium text-surface-600">
//                           Status
//                         </th>

//                         {!isView && (
//                           <th className="w-24 px-2 text-center font-medium text-surface-600">
//                             Actions
//                           </th>
//                         )}
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {/* Existing saved components */}
//                       {currentSalaryComponents.map(
//                         (component) => (
//                           <tr
//                             key={`saved-${component.id}`}
//                             className="border-t border-surface-100"
//                           >
//                             <td className="px-3 py-2 font-medium text-surface-800">
//                               {component.componentName}
//                             </td>

//                             <td className="px-3 py-2 text-right tabular-nums text-surface-700">
//                               {fmtMoney(component.amount)}
//                             </td>

//                             <td className="px-3 py-2 text-center tabular-nums text-surface-600">
//                               {toIsoDate(
//                                 component.effectiveDate
//                               )}
//                             </td>

//                             <td className="px-3 py-2 text-center tabular-nums text-surface-600">
//                               {toIsoDate(
//                                 component.endDate
//                               )}
//                             </td>

//                             <td className="px-3 py-2 text-center">
//                               <StatusPill
//                                 label={
//                                   component.isActive
//                                     ? "Active"
//                                     : "Inactive"
//                                 }
//                               />
//                             </td>

//                             {!isView && (
//                               <td className="px-2">
//                                 <div className="flex items-center justify-center gap-1">
//                                   <button
//                                     type="button"
//                                     onClick={() =>
//                                       handleEditExistingComponent(component)
//                                     }
//                                     disabled={saving}
//                                     className="
//                                       inline-flex
//                                       h-7
//                                       items-center
//                                       justify-center
//                                       rounded
//                                       px-2
//                                       text-[11px]
//                                       font-medium
//                                       text-primary-600
//                                       transition-colors
//                                       hover:bg-primary-50
//                                       disabled:cursor-not-allowed
//                                       disabled:opacity-50
//                                     "
//                                     title="Edit component"
//                                   >
//                                     <Pencil size={13} />
//                                   </button>

//                                   {component.isActive !== false ? (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         handleToggleExistingComponentStatus(component, false)
//                                       }
//                                       disabled={saving}
//                                       className="
//                                         inline-flex
//                                         h-7
//                                         w-7
//                                         items-center
//                                         justify-center
//                                         rounded
//                                         text-gray-400
//                                         transition-colors
//                                         hover:bg-red-50
//                                         hover:text-red-600
//                                         disabled:cursor-not-allowed
//                                         disabled:opacity-50
//                                       "
//                                       title="Deactivate component"
//                                     >
//                                       <Trash2 size={13} />
//                                     </button>
//                                   ) : (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         handleToggleExistingComponentStatus(component, true)
//                                       }
//                                       disabled={saving}
//                                       className="
//                                         inline-flex
//                                         h-7
//                                         w-7
//                                         items-center
//                                         justify-center
//                                         rounded
//                                         text-emerald-400
//                                         transition-colors
//                                         hover:bg-emerald-50
//                                         hover:text-emerald-600
//                                         disabled:cursor-not-allowed
//                                         disabled:opacity-50
//                                       "
//                                       title="Reactivate component"
//                                     >
//                                       <RotateCcw size={13} />
//                                     </button>
//                                   )}

//                                 </div>
//                               </td>
//                             )}
//                           </tr>
//                         )
//                       )}

//                       {/* Pending components */}
//                       {pendingComponents.map(
//                         (component, index) => {
//                           const componentName =
//                             payrollComponents.find(
//                               (item) =>
//                                 String(item.id) ===
//                                 String(
//                                   component.componentId
//                                 )
//                             )?.name ??
//                             "-";

//                           return (
//                             <tr
//                               key={`pending-${index}`}
//                               className="border-t border-primary-100 bg-primary-50/40"
//                             >
//                               <td className="px-3 py-2 font-medium text-surface-800">
//                                 {componentName}
//                                 <span className="ml-2 rounded bg-primary-100 px-1.5 py-0.5 text-[9px] font-medium text-primary-700">
//                                   New
//                                 </span>
//                               </td>

//                               <td className="px-3 py-2 text-right tabular-nums text-surface-700">
//                                 {fmtMoney(
//                                   component.amount
//                                 )}
//                               </td>

//                               <td className="px-3 py-2 text-center tabular-nums text-surface-600">
//                                 {toIsoDate(
//                                   component.effectiveDate
//                                 )}
//                               </td>

//                               <td className="px-3 py-2 text-center tabular-nums text-surface-600">
//                                 {toIsoDate(
//                                   component.endDate
//                                 )}
//                               </td>

//                               <td className="px-3 py-2 text-center">
//                                 <StatusPill label="Active" />
//                               </td>

//                               <td className="px-2 text-center">
//                                 <button
//                                   type="button"
//                                   onClick={() =>
//                                     handleRemovePendingComponent(
//                                       index
//                                     )
//                                   }
//                                   className="
//                                     inline-flex
//                                     h-7
//                                     w-7
//                                     items-center
//                                     justify-center
//                                     rounded
//                                     text-gray-400
//                                     transition-colors
//                                     hover:bg-red-50
//                                     hover:text-red-600
//                                   "
//                                   title="Remove"
//                                 >
//                                   <Trash2 size={13} />
//                                 </button>
//                               </td>
//                             </tr>
//                           );
//                         }
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}

//             {/* Add Component Inline Form */}
//             {showComponentForm && !isView && (
//               <div className="
//                 mt-3
//                 rounded-md
//                 border
//                 border-surface-200
//                 bg-surface-50
//                 p-3
//               ">
//                 <div className="mb-3 flex items-center justify-between">
//                   <div>
//                     <h4 className="text-xs font-semibold text-surface-800">
//                       {editingComponentId ? "Edit Salary Component" : "New Salary Component"}
//                     </h4>

//                     <p className="text-[11px] text-surface-500">
//                       {editingComponentId ? "Update the component details." : "Add the component details before saving."}
//                     </p>
//                   </div>

//                   <button
//                     type="button"
//                     onClick={resetComponentForm}
//                     className="
//                       inline-flex
//                       h-6
//                       w-6
//                       items-center
//                       justify-center
//                       rounded
//                       text-surface-400
//                       hover:bg-white
//                       hover:text-surface-700
//                     "
//                     title="Close"
//                   >
//                     <X size={14} />
//                   </button>
//                 </div>

//                 <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">

//                   {/* Component */}
//                   <SelectInput
//                     label="Salary Component"
//                     value={
//                       componentForm.componentId
//                     }
//                     error={componentErrors.componentId}
//                     onChange={(event) => {
//                       const selectedId = event.target.value;
//                       handleComponentChange("componentId", event.target.value);

//                       if (selectedId) {
//                         const selectedComp = payrollComponents.find((c) => String(c.id) === String(selectedId));

//                         if (selectedComp && selectedComp.defaultAmount > 0) {
//                           const formattedDefault = maskCurrencyInput(Number(selectedComp.defaultAmount).toFixed(2));
//                           handleComponentChange("amount", formattedDefault)
//                         } else {
//                           handleComponentChange("amount", "");
//                         }
//                       } else {
//                         handleComponentChange("amount", "");
//                       }
//                     }}
//                   >
//                     <option value="">
//                       Select Salary Component
//                     </option>

//                     {payrollComponents
//                       .filter((component) => !component.basic)
//                       .map(
//                         (component) => (
//                           <option
//                             key={component.id}
//                             value={component.id}
//                           >
//                             {component.name}
//                           </option>
//                         )
//                       )
//                     }
//                   </SelectInput>

//                   {/* Amount */}
//                   <CurrencyInput
//                     label="Amount"
//                     value={componentForm.amount}
//                     error={componentErrors.amount}
//                     onChange={(value) =>
//                       handleComponentChange("amount", value)
//                     }
//                   />

//                   {/* Effective */}
//                   <DateInput
//                     label="Effective Start Date"
//                     value={
//                       componentForm.effectiveDate
//                     }
//                     error={componentErrors.effectiveDate}
//                     onChange={(value) =>
//                       handleComponentChange(
//                         "effectiveDate", value
//                         // event.target.value
//                       )
//                     }
//                   />

//                   {/* End */}
//                   <DateInput
//                     label="Effective End Date"
//                     value={componentForm.endDate}
//                     error={componentErrors.endDate}
//                     onChange={(value) =>
//                       handleComponentChange(
//                         "endDate", value
//                         // event.target.value
//                       )
//                     }
//                   />

//                   {/* Remarks */}
//                   <TextArea
//                     label="Remarks"
//                     value={componentForm.remarks}
//                     rows={1}
//                     className="sm:col-span-2"
//                     onChange={(event) =>
//                       handleComponentChange(
//                         "remarks",
//                         event.target.value
//                       )
//                     }
//                   />

//                   {/* Active */}
//                   {/* <div className="flex items-center">
//                     <CheckboxInput
//                       label="Active"
//                       checked={
//                         componentForm.isActive
//                       }
//                       onChange={(event) =>
//                         handleComponentChange(
//                           "isActive",
//                           event.target.checked
//                         )
//                       }
//                     />
//                   </div> */}
//                 </div>

//                 <div className="mt-3 flex justify-end gap-2">
//                   <Button
//                     type="button"
//                     size="small"
//                     onClick={resetComponentForm}
//                     className="!px-3 !py-1.5 !text-xs !text-surface-600"
//                   >
//                     Cancel
//                   </Button>

//                   <Button
//                     type="button"
//                     size="small"
//                     variant="contained"
//                     startIcon={editingComponentId ? null : <Plus size={13} />}
//                     onClick={
//                       editingComponentId ? handleUpdateExistingComponent : handleAddPendingComponent
//                     }
//                     disabled={saving}
//                     className="
//                       !bg-primary-600
//                       !px-3
//                       !py-1.5
//                       !text-xs
//                       hover:!bg-primary-700
//                     "
//                   >
//                     {editingComponentId ? "Update" : "Add"}
//                   </Button>
//                 </div>
//               </div>
//             )}
//           </section>
//         </div>
//       </DialogContent>

//       {/* ──────────────────────────────────────────────────────────────── */}
//       {/* Footer                                                          */}
//       {/* ──────────────────────────────────────────────────────────────── */}

//       <DialogActions className="!border-t !border-surface-100 !px-6 !py-3">
//         <Button
//           type="button"
//           onClick={onClose}
//           disabled={saving}
//           className="!px-3 !text-sm !text-primary-600"
//         >
//           {isView ? "CLOSE" : "CANCEL"}
//         </Button>

//         {!isView && (
//           <Button
//             type="button"
//             variant="contained"
//             onClick={handleSave}
//             disabled={saving}
//             className="
//               !bg-primary-600
//               !px-4
//               !text-sm
//               hover:!bg-primary-700
//             "
//           >
//             {saving
//               ? "SAVING..."
//               : isEdit
//                 ? "UPDATE"
//                 : "SAVE"}
//           </Button>
//         )}
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default EmployeeSalaryDialog;

// ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// ----------------------- VERSTION 2
// ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------

// import { useCallback, useEffect, useMemo, useState } from "react";
// import {
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogActions,
//   Button,
// } from "@mui/material";
// import {
//   Pencil,
//   Plus,
//   RotateCcw,
//   Trash2,
//   X,
// } from "lucide-react";
// import { toast } from "react-toastify";

// import { fmtMoney } from "../../utils/payrollFormat";
// import { toIsoDate } from "../../utils/dateFormat";
// import { StatusPill } from "../Table/Table";
// import IsoDateInput from "../common/Isodateinput";

// /* ────────────────────────────────────────────────────────────────────────── */
// /* Constants                                                                  */
// /* ────────────────────────────────────────────────────────────────────────── */

// const INITIAL_SALARY_FORM = {
//   employeeId: "",
//   salaryReference: "",
//   basic: "",
//   effectiveDate: "",
//   endDate: "",
//   payFrequency: "M",
//   grossSalary: 0,
//   workingDays: null,
//   dailyRate: "",
//   isCurrent: true,
//   isActive: true,
//   remarks: "",
// };

// const INITIAL_COMPONENT_FORM = {
//   componentId: "",
//   amount: "",
//   percentage: 0,
//   effectiveDate: "",
//   endDate: "",
//   isActive: true,
//   remarks: "",
// };

// const PAY_FREQUENCIES = [
//   {
//     value: "M",
//     label: "Monthly",
//   },
//   {
//     value: "W",
//     label: "Weekly",
//   },
// ];

// const getOneYearFromToday = (date) => {
//   const d = new Date(date);
//   d.setFullYear(d.getFullYear() + 1);
//   return d;
// }

// const getLastDayOfThisMonth = (date) => {
//   const d = new Date(date);
//   return new Date(d.getFullYear(), d.getMonth() + 1, 0);
// }

// const maskCurrencyInput = (rawValue) => {
//   const digits = String(rawValue ?? "").replace(/\D/g, "");

//   if (!digits) return "";

//   const padded = digits.padStart(3, "0");
//   const cents = padded.slice(-2);

//   const wholeDigits = padded.slice(0, -2).replace(/^0+(?=\d)/, "");
//   const whole = Number(wholeDigits || "0").toLocaleString("en-US");

//   return `${whole}.${cents}`;
// }

// const parseCurrency = (value) => {
//   if (value === "" || value === null) return 0;
//   const n = Number(String(value).replace(/,/g, ""));
//   return Number.isNaN(n) ? 0 : n;
// }

// /* ────────────────────────────────────────────────────────────────────────── */
// /* Styles                                                                     */
// /* ────────────────────────────────────────────────────────────────────────── */

// const INPUT_CLASS = `
//   w-full h-10
//   rounded-md
//   border border-surface-200
//   bg-white
//   px-3
//   text-sm text-surface-800
//   outline-none
//   transition-colors
//   focus:border-primary-500
//   focus:ring-1 focus:ring-primary-500
// `;

// const DISABLED_INPUT_CLASS = `
//   !bg-gray-100
//   !text-gray-500
//   !border-gray-300
//   cursor-not-allowed
// `;

// const LABEL_CLASS = `
//   absolute
//   left-2.5
//   top-0
//   -translate-y-1/2
//   bg-white
//   px-1
//   text-[11px]
//   text-surface-500
//   pointer-events-none
//   z-10
// `;

// const SECTION_TITLE_CLASS = `
//   text-sm
//   font-semibold
//   text-surface-900
// `;

// const SECTION_SUBTITLE_CLASS = `
//   mt-0.5
//   text-xs
//   text-surface-500
// `;

// /* ────────────────────────────────────────────────────────────────────────── */
// /* Small Form Components                                                      */
// /* ────────────────────────────────────────────────────────────────────────── */

// function Field({ label, children, className = "", error = "", }) {
//   return (
//     <div className={`relative ${className}`}>
//       <label className={LABEL_CLASS}>
//         {label}
//       </label>

//       {children}

//       {error && (
//         <p className="mt-1.5 flex items-start gap-1 text-xs text-red-600">
//           {error}
//         </p>
//       )}
//     </div>
//   );
// }

// function TextInput({
//   label,
//   value,
//   onChange,
//   type = "text",
//   disabled = false,
//   placeholder = "",
//   min,
//   step,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <input
//         type={type}
//         value={value ?? ""}
//         onChange={onChange}
//         disabled={disabled}
//         placeholder={placeholder}
//         min={min}
//         step={step}
//         className={`${INPUT_CLASS} ${
//           disabled ? DISABLED_INPUT_CLASS : ""
//         } ${
//             error ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500" : ""
//         }`}
//       />
//     </Field>
//   );
// }

// function CurrencyInput({
//   label,
//   value,
//   onChange,
//   disabled = false,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <input
//         type="text"
//         inputMode="decimal"
//         value={value ?? ""}
//         disabled={disabled}
//         onChange={(event) =>
//           onChange(maskCurrencyInput(event.target.value))
//         }
//         className={`${INPUT_CLASS} ${
//           disabled ? DISABLED_INPUT_CLASS : ""
//         } ${
//           error
//             ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500"
//             : ""
//         }`}
//       />
//     </Field>
//   )
// }

// function DateInput({
//   label,
//   value,
//   onChange,
//   disabled = false,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <IsoDateInput
//         value={value ?? ""}
//         onChange={onChange}
//         disabled={disabled}
//         className={`${INPUT_CLASS} appearance-none ${
//           disabled ? DISABLED_INPUT_CLASS : ""
//         } ${
//             error ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500" : ""
//         }`}
//       />
//     </Field>
//   );
// }

// function SelectInput({
//   label,
//   value,
//   onChange,
//   children,
//   disabled = false,
//   error = "",
// }) {
//   return (
//     <Field label={label} error={error}>
//       <select
//         value={value ?? ""}
//         onChange={onChange}
//         disabled={disabled}
//         className={`${INPUT_CLASS} appearance-auto cursor-pointer ${
//           disabled ? DISABLED_INPUT_CLASS : ""
//         } ${
//             error ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500" : ""
//         }`}
//       >
//         {children}
//       </select>
//     </Field>
//   );
// }

// function TextArea({
//   label,
//   value,
//   onChange,
//   disabled = false,
//   rows = 2,
//   error = "",
//   className = "",
// }) {
//   return (
//     <Field label={label} error={error} className={className}>
//       <textarea
//         value={value ?? ""}
//         onChange={onChange}
//         disabled={disabled}
//         rows={rows}
//         className={`
//           w-full
//           rounded-md
//           border border-surface-200
//           bg-white
//           px-3
//           py-2.5
//           text-sm
//           text-surface-800
//           outline-none
//           transition-colors
//           focus:border-primary-500
//           focus:ring-1
//           focus:ring-primary-500
//           resize-none
//           ${disabled ? DISABLED_INPUT_CLASS : ""}
//           ${error ? "!border-red-400 focus:!border-red-500 focus:!ring-red-500" : ""}
//         `}
//       />
//     </Field>
//   );
// }

// function CheckboxInput({
//   label,
//   checked,
//   onChange,
//   disabled = false,
// }) {
//   return (
//     <label
//       className={`
//         flex
//         items-center
//         gap-2
//         text-sm
//         text-surface-700
//         ${disabled ? "cursor-not-allowed text-gray-500" : "cursor-pointer"}
//       `}
//     >
//       <input
//         type="checkbox"
//         checked={Boolean(checked)}
//         onChange={onChange}
//         disabled={disabled}
//         className="
//           h-4
//           w-4
//           rounded
//           border-surface-300
//           accent-primary-600
//         "
//       />

//       {label}
//     </label>
//   );
// }

// /* ────────────────────────────────────────────────────────────────────────── */
// /* Main Component                                                             */
// /* ────────────────────────────────────────────────────────────────────────── */

// const EmployeeSalaryDialog = ({
//   open,
//   onClose,
//   onSave,
//   onSaveComponent,
//   onExited,

//   employees = [],
//   employeeSalaries = [],
//   salary = null,
//   mode = "add",

//   salaryComponents = [],
//   payrollComponents = [],
// }) => {
//   const isAdd = mode === "add";
//   const isEdit = mode === "edit";
//   const isView = mode === "view";

//   const [salaryForm, setSalaryForm] = useState(INITIAL_SALARY_FORM);
//   const [componentForm, setComponentForm] = useState(INITIAL_COMPONENT_FORM);
//   const [showComponentForm, setShowComponentForm] = useState(false);
//   const [pendingComponents, setPendingComponents] = useState([]);
//   const [editingPendingIndex, setEditingPendingIndex] = useState(null);
//   const [editingComponentId, setEditingComponentId] = useState(null);
//   const [saving, setSaving] = useState(false);
//   const [errors, setErrors] = useState({});
//   const [componentErrors, setComponentErrors] = useState({});
//   const [salaryReferenceAuto, setSalaryReferenceAuto] = useState(true);
//   const [showPreviousRecords, setShowPreviousRecords] = useState(false);

//   const isEditingComponent = showComponentForm && (Boolean(editingComponentId) || editingPendingIndex !== null);

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Initialize Salary Form                                                   */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   useEffect(() => {
//     if (!open) {
//       return;
//     }

//     setErrors({});
//     setShowComponentForm(false);
//     setShowPreviousRecords(false);
//     setComponentForm(INITIAL_COMPONENT_FORM);
//     setPendingComponents([]);
//     setEditingComponentId(null);
//     setEditingPendingIndex(null);
//     setComponentErrors({});
//     setSalaryReferenceAuto(true);

//     if (salary && (isEdit || isView)) {
//       setSalaryForm({
//         employeeId: salary.employeeId ?? "",
//         salaryReference: salary.salaryReference ?? "",
//         effectiveDate:
//           toIsoDate(salary.effectiveDate) ?? "",
//         endDate:
//           toIsoDate(salary.endDate) ?? "",
//         payFrequency:
//           salary.payFrequency === "Monthly"
//             ? "M"
//             : salary.payFrequency === "Weekly"
//               ? "W"
//               : salary.payFrequency ?? "M",
//         grossSalary: salary.grossSalary ?? "",
//         workingDays: salary.workingDays ?? "",
//         basic: salary.basic !== null ? maskCurrencyInput(String(Math.round(Number(salary.basic) * 100))) : "",
//         dailyRate: salary.dailyRate !== null ? maskCurrencyInput(String(Math.round(Number(salary.dailyRate) * 100))) : "",
//         isCurrent: salary.isCurrent ?? true,
//         isActive: salary.isActive ?? true,
//         remarks: salary.remarks ?? "",
//       });

//       return;
//     }

//     const today = new Date();

//     setSalaryForm({
//       ...INITIAL_SALARY_FORM,
//       effectiveDate: toIsoDate(today),
//       endDate: toIsoDate(getOneYearFromToday(today)),
//     });

//     setSalaryReferenceAuto(true);
//   }, [
//     open,
//     salary,
//     isEdit,
//     isView,
//   ]);

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Components belonging to current salary                                   */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const currentSalaryComponents = useMemo(() => {
//     if (!salary?.id) {
//       return [];
//     }

//     return salaryComponents
//       .filter(
//         (component) =>
//           String(component.employeeSalaryId) ===
//           String(salary.id)
//       )
//       .filter((component) => {
//         const payrollComponent = payrollComponents.find(
//           (payrollComponent) => String(payrollComponent.id) === String(component.componentId)
//         );

//         return (
//           payrollComponent && !payrollComponent.basic && payrollComponent.type === "Earning"
//         )
//       })
//       .map((component) => {
//         const payrollComponent = payrollComponents.find(
//           (payrollComponent) => String(payrollComponent.id) === String(component.componentId)
//         );

//         return {
//           ...component,
//           componentName: payrollComponent?.name ?? "-"
//         }
//       });
//   }, [
//     salary,
//     salaryComponents,
//     payrollComponents,
//   ]);

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Employee Assigned Check                                                  */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const isEmployeeAssigned = useCallback((employeeId) => {
//     // Do not perform the period check until both dates are entered
//     if (!salaryForm.effectiveDate || !salaryForm.endDate) {
//       return false;
//     }

//     const newStart = new Date(salaryForm.effectiveDate);
//     const newEnd = new Date(salaryForm.endDate);

//     return employeeSalaries.some((salaryRecord) => {
//         // Don't compare the salary against itself while editing
//         if (
//           isEdit &&
//           String(salaryRecord.id) === String(salary?.id)
//         ) {
//           return false;
//         }

//         // Only check salary records belonging to this employee
//         if (String(salaryRecord.employeeId) !== String(employeeId)) {
//             return false;
//         }

//         // Ignore records without a complete effective period
//         if (!salaryRecord.effectiveDate || !salaryRecord.endDate) {
//             return false;
//         }

//         const existingStart = new Date(salaryRecord.effectiveDate);
//         const existingEnd = new Date(salaryRecord.endDate);

//         // Check for period overlap
//         return (newStart <= existingEnd && newEnd >= existingStart);
//       }
//     );
//   }, [
//     salaryForm.effectiveDate,
//     salaryForm.endDate,
//     employeeSalaries,
//     isEdit,
//     salary?.id
//   ]);

//   const generateSalaryReference = (employee, existingRefs = []) => {
//     if (!employee) return "";
//     const base = `SAL-${employee.HED_SERVICE_NO}-${Date.now().toString().slice(-5)}`;
//     let candidate = base;
//     let suffix = 1;
//     while (existingRefs.includes(candidate)) {
//       candidate = `${base}-${suffix++}`;
//     }
//     return candidate;
//   }

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Form Changes                                                             */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const handleSalaryChange = (key, value) => {
//     if (isView) {
//       return;
//     }

//     let salaryReference;

//     if (key === "employeeId" && isAdd && salaryReferenceAuto) {
//       const employee = employees.find((e) => String(e.HED_EMPLOYEE_ID) === String(value));
//       const existingRefs = employeeSalaries.map((s) => s.salaryReference);

//       salaryReference = generateSalaryReference(employee, existingRefs);
//     }

//     if (key === "salaryReference") {
//       setSalaryReferenceAuto(false);
//     }

//     setSalaryForm((previous) => ({
//       ...previous,
//       [key]: value,

//       ...(salaryReference !== undefined ? { salaryReference } : {}),

//       ...(key === "payFrequency" && value === "W" ? { basic: "" } : {}),
//     }));

//     setErrors((prev) => {
//         if (!prev[key]) {
//             return prev;
//         }

//         const next = { ...prev };
//         delete next[key];

//         if (key === "payFrequency" && value === "W") {
//           delete next.basic;
//         }

//         return next;
//     })
//   };

//   const handleComponentChange = (key, value) => {
//     if (isView) {
//       return;
//     }

//     setComponentForm((previous) => ({
//       ...previous,
//       [key]: value,
//     }));

//     // Clear field error when user starts changing it
//     setComponentErrors((prev) => {
//       if (!prev[key]) return prev;
//       const next = { ...prev };
//       delete next[key];
//       return next;
//     })
//   };

//   const handleEditPendingComponent = (index) => {
//     if (isView) return;

//     const comp = pendingComponents[index];
//     setEditingPendingIndex(index);
//     setEditingComponentId(null);

//     setComponentForm({
//       componentId: comp.componentId ?? "",
//       amount: comp.amount != null ? maskCurrencyInput(String(Math.round(Number(comp.amount) * 100))) : "",
//       percentage: comp.percentage ?? 0,
//       effectiveDate: comp.effectiveDate ?? "",
//       endDate: comp.endDate ?? "",
//       isActive: comp.isActive ?? true,
//       remarks: comp.remarks ?? "",
//     });

//     setShowComponentForm(true);
//   }

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Component Form                                                           */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const resetComponentForm = () => {
//     setComponentForm(INITIAL_COMPONENT_FORM);
//     setEditingComponentId(null);
//     setEditingPendingIndex(null);
//     setShowComponentForm(false);
//     setComponentErrors({});
//   };

//   const handleEditExistingComponent = (component) => {
//     if (isView) return;

//     setEditingComponentId(component.id);

//     setComponentForm({
//       employeeSalaryComponentId: component.employeeSalaryComponentId ?? component.id,
//       componentId: component.componentId ?? "",
//       amount: component.amount != null
//         ? maskCurrencyInput(String(Math.round(Number(component.amount) * 100)))
//         : component.componentAmount != null ? maskCurrencyInput(String(Math.round(Number(component.componentAmount) * 100)))
//         : "",
//       percentage: component.percentage ?? component.componentPercentage ?? 0,
//       effectiveDate: toIsoDate(component.effectiveDate) ?? "",
//       endDate: toIsoDate(component.endDate) ?? "",
//       isActive: component.isActive ?? true,
//       remarks: component.remarks ?? "",
//     });

//     setShowComponentForm(true);
//   }

//   const handleAddPendingComponent = () => {
//     const validationErrors = {};

//     if (!componentForm.componentId) {
//       validationErrors.componentId = "Please select a salary component.";
//     }

//     if (
//       componentForm.amount === "" ||
//       parseCurrency(componentForm.amount) < 0
//     ) {
//       validationErrors.amount = "Please enter a valid amount.";
//     }

//     if (!componentForm.effectiveDate) {
//       validationErrors.effectiveDate = "Please select the component effective start date.";
//     }

//     if (!componentForm.endDate) {
//       validationErrors.endDate = "Please select the component end date.";
//     }

//     if (
//       new Date(componentForm.effectiveDate) >
//       new Date(componentForm.endDate)
//     ) {
//       validationErrors.endDate = "Component end date cannot be before the effective date.";
//     }

//     const duplicate = pendingComponents.some(
//       (component, idx) =>
//         idx !== editingPendingIndex &&
//         String(component.componentId) === String(componentForm.componentId)
//     );

//     if (duplicate) {
//       validationErrors.componentId = "This salary component has already been added.";
//     }

//     if (Object.keys(validationErrors).length > 0) {
//       setComponentErrors(validationErrors);
//       return;
//     }

//     const formattedItem = {
//       ...componentForm,
//       amount: componentForm.amount === "" ? 0 : parseCurrency(componentForm.amount),
//       percentage: Number(componentForm.percentage || 0),
//       isActive: true,
//     };

//     if (editingPendingIndex !== null) {
//       setPendingComponents((previous) =>
//         previous.map((item, idx) => (idx === editingPendingIndex ? formattedItem : item))
//       );
//     } else {
//       setPendingComponents((previous) => [...previous, formattedItem]);
//     }

//     resetComponentForm();
//   };

//   const handleUpdateExistingComponent = async () => {
//     if (!editingComponentId) return;

//     const validationErrors = {};

//     if (!componentForm.componentId) {
//       validationErrors.componentId = "Please select a salary component.";
//     }

//     if (componentForm.amount === "" || parseCurrency(componentForm.amount) < 0) {
//       validationErrors.amount = "Please enter a valid amount."
//     }

//     if (!componentForm.effectiveDate) {
//       validationErrors.effectiveDate = "Please select the component effective start date."
//     }

//     if (!componentForm.endDate) {
//       validationErrors.endDate = "Please select the component effective end date."
//     }

//     if (
//       new Date(componentForm.effectiveDate) >
//       new Date(componentForm.endDate)
//     ) {
//       validationErrors.endDate =
//         "Component end date cannot be before the effective date.";
//     }

//     if (Object.keys(validationErrors).length > 0) {
//       setComponentErrors(validationErrors);
//       return;
//     }

//     setSaving(true);

//     try {
//       await onSaveComponent(
//         {
//           employeeSalaryComponentId: componentForm.employeeSalaryComponentId ?? editingComponentId,
//           employeeSalaryId: salary?.id,
//           componentId: componentForm.componentId,
//           componentAmount: parseCurrency(componentForm.amount),
//           componentPercentage: Number(componentForm.percentage || 0),
//           effectiveDate: componentForm.effectiveDate,
//           endDate: componentForm.endDate,
//           isActive: componentForm.isActive !== false,
//           remarks: componentForm.remarks ?? "",
//         },
//         true
//       );

//       resetComponentForm();
//     } catch (error) {
//       console.error("Failed to update salary component: ", error);
//     } finally {
//       setSaving(false);
//     }
//   }

//   const handleToggleExistingComponentStatus = async (component, newActiveState) => {
//     const componentId = component.employeeSalaryComponentId ?? component.id;
//     setSaving(true);

//     try {
//       await onSaveComponent({
//         employeeSalaryComponentId: componentId,
//         employeeSalaryId: salary?.id,
//         componentId: component.componentId,
//         componentAmount: parseCurrency(component.amount ?? component.componentAmount ?? 0),
//         componentPercentage: Number(component.percentage ?? component.componentPercentage ?? 0),
//         effectiveDate: component.effectiveDate,
//         endDate: component.endDate,
//         isActive: newActiveState,
//         remarks: component.remarks ?? "",
//       },
//       true);
//     } catch (error) {
//       console.error(`Failed to ${newActiveState ? "reactivate" : "remove"} salary component: `, error);
//     } finally {
//       setSaving(false);
//     }
//   }

//   const handleRemovePendingComponent = (index) => {
//     setPendingComponents((previous) =>
//       previous.filter((_, itemIndex) => itemIndex !== index)
//     );
//   };

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Save and Validation                                                      */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const handleSave = async () => {
//     if (isView) {
//       onClose?.();
//       return;
//     }

//     if (isEditingComponent) {
//       return;
//     }

//     const validationErrors = {};

//     if (!salaryForm.employeeId) {
//         validationErrors.employeeId = "Please select an employee.";
//     } else if (isAdd && isEmployeeAssigned(salaryForm.employeeId)) {
//         validationErrors.employeeId = "This employee already has a salary assigned for this effective period.";
//     }

//     // if (!String(salaryForm.salaryReference).trim()) {
//     //     validationErrors.salaryReference = "Salary reference is required.";
//     // }

//     if (!salaryForm.dailyRate || parseInt(salaryForm.dailyRate) < 0) {
//         validationErrors.dailyRate = "Daily Rate is required and cannot be negative."
//     }

//     const duplicateRef = employeeSalaries.some(
//       (s) => String(s.salaryReference ?? "").trim().toLowerCase() === String(salaryForm.salaryReference ?? "").trim().toLowerCase() &&
//       !(isEdit && String(s.id) === String(salary?.id))
//     );

//     if (duplicateRef) {
//       validationErrors.salaryReference = "This salary reference is already in use.";
//     }

//     if (salaryForm.payFrequency !== "W") {
//       if (!salaryForm.basic) {
//         validationErrors.basic =
//           "Please enter a basic salary.";
//       } else if (parseCurrency(salaryForm.basic) < 0) {
//         validationErrors.basic =
//           "Basic salary must be positive.";
//       }
//     }

//     if (!salaryForm.effectiveDate) {
//         validationErrors.effectiveDate = "Please select an effective start date.";
//     }

//     if (!salaryForm.endDate) {
//         validationErrors.endDate = "Please select an effective end date.";
//     }

//     if (salaryForm.effectiveDate && salaryForm.endDate && new Date(salaryForm.effectiveDate) > new Date(salaryForm.endDate)) {
//         validationErrors.endDate = "End date cannot be before the starting date.";
//     }

//     if (salaryForm.workingDays !== "" && Number(salaryForm.workingDays) < 0) {
//         validationErrors.workingDays = "Working days cannot be negative.";
//     }

//     if (salaryForm.dailyRate !== "" && parseCurrency(salaryForm.dailyRate) < 0) {
//         validationErrors.dailyRate = "Daily rate cannot be negative.";
//     }

//     setErrors(validationErrors);

//     // Stop if validation failed
//     if (Object.keys(validationErrors).length > 0) {
//         // toast.error(Object.values(validationErrors)[0]);
//         return;
//     }

//     setSaving(true);

//     try {
//       const salaryPayload = {
//         ...salaryForm,

//         ...(isEdit && {
//           id: salary?.id,
//         }),

//         basic: salaryForm.payFrequency === "W" ? 0 : parseCurrency(salaryForm.basic),

//         grossSalary: Number(salaryForm.grossSalary || 0),

//         workingDays:
//           salaryForm.workingDays === ""
//             ? undefined
//             : Number(salaryForm.workingDays || 0),

//         dailyRate:
//           salaryForm.dailyRate === ""
//             ? undefined
//             : parseCurrency(salaryForm.dailyRate),
//       };

//       /*
//        * The parent is responsible for saving the employee salary.
//        *
//        * onSave should ideally return the saved salary record:
//        *
//        * {
//        *   id: 123,
//        *   ...
//        * }
//        *
//        * This allows the parent to save pending components
//        * using the newly-created employeeSalaryId.
//        */
//       await onSave?.(
//         salaryPayload,
//         pendingComponents
//       );

//       setPendingComponents([]);
//       setComponentForm(INITIAL_COMPONENT_FORM);
//       setShowComponentForm(false);
//     } catch (error) {
//       console.error(
//         "Failed to save employee salary:",
//         error
//       );

//       toast.error(
//         "Failed to save employee salary."
//       );
//     } finally {
//       setSaving(false);
//     }
//   };

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Employee Name                                                            */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const selectedEmployee = useMemo(() => {
//     return employees.find(
//       (employee) =>
//         String(employee.HED_EMPLOYEE_ID) ===
//         String(salaryForm.employeeId)
//     );
//   }, [
//     employees,
//     salaryForm.employeeId,
//   ]);

//   // Previous salary lookuup
//   const previousSalaries = useMemo(() => {
//     if (!salaryForm.employeeId) return [];

//     const empSalaries = employeeSalaries.filter(
//       (s) =>
//         String(s.employeeId) === String(salaryForm.employeeId) &&
//         String(s.id) !== String(salary?.id) // exclude the one currently being edited
//     );

//     // Sort descending by effective date so the most recent past salaries are at the top
//     return empSalaries.sort(
//       (a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate)
//     );
//   }, [salaryForm.employeeId, employeeSalaries, salary?.id]);

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Title                                                                    */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   const title = isAdd
//     ? "Assign Employee Salary"
//     : isEdit
//       ? "Update Employee Salary"
//       : "Employee Salary Details";

//   /* ──────────────────────────────────────────────────────────────────────── */
//   /* Render                                                                   */
//   /* ──────────────────────────────────────────────────────────────────────── */

//   return (
//     <Dialog
//       open={open}
//       onClose={saving ? undefined : onClose}
//       maxWidth="md"
//       fullWidth
//       TransitionProps={{
//         onExited: () => {
//           setSalaryForm(INITIAL_SALARY_FORM);
//           setComponentForm(INITIAL_COMPONENT_FORM);
//           setPendingComponents([]);
//           setShowComponentForm(false);
//           setShowPreviousRecords(false);
//           setErrors({});
//           setComponentErrors({});
//           setSaving(false);
//           setSalaryReferenceAuto(true);
//           onExited?.();
//         },
//       }}
//     >
//       {/* ──────────────────────────────────────────────────────────────── */}
//       {/* Header                                                          */}
//       {/* ──────────────────────────────────────────────────────────────── */}

//       <DialogTitle className="!px-6 !pt-5 !pb-3">
//         <div className="flex items-center justify-between gap-4">
//           <div>
//             <h2 className="text-lg font-semibold text-surface-900">
//               {title}
//             </h2>

//             {selectedEmployee && (
//               <p className="mt-0.5 text-xs text-surface-500">
//                 {selectedEmployee.HED_SERVICE_NO}{" "}
//                 -{" "}
//                 {selectedEmployee.HED_REPORT_NAME}
//               </p>
//             )}
//           </div>
//         </div>
//       </DialogTitle>

//       <DialogContent className="!px-6 !py-4">
//         <div className="space-y-6">

//           {/* ────────────────────────────────────────────────────────── */}
//           {/* Employee Salary Details                                   */}
//           {/* ────────────────────────────────────────────────────────── */}

//           <section>
//             <div className="mb-5">
//               <h3 className={SECTION_TITLE_CLASS}>
//                 Employee Salary Details
//               </h3>

//               <p className={SECTION_SUBTITLE_CLASS}>
//                 Configure the employee's salary and effective period.
//               </p>
//             </div>

//             <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">

//               {/* Employee */}
//               <SelectInput
//                 label="Employee"
//                 value={salaryForm.employeeId}
//                 disabled={!isAdd || isView}
//                 error={errors.employeeId}
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "employeeId",
//                     event.target.value
//                   )
//                 }
//               >
//                 <option value="">
//                   Select Employee
//                 </option>

//                 {employees.map((employee) => (
//                     <option
//                       key={employee.HED_EMPLOYEE_ID}
//                       value={employee.HED_EMPLOYEE_ID}
//                     >
//                       {employee.HED_SERVICE_NO} -{" "}
//                       {employee.HED_REPORT_NAME}
//                     </option>
//                   ))}
//               </SelectInput>

//               {/* Pay Frequency */}
//               <SelectInput
//                 label="Pay Frequency"
//                 value={salaryForm.payFrequency}
//                 error={errors.payFrequency}
//                 disabled={isView}
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "payFrequency",
//                     event.target.value
//                   )
//                 }
//               >
//                 {PAY_FREQUENCIES.map(
//                   (frequency) => (
//                     <option
//                       key={frequency.value}
//                       value={frequency.value}
//                     >
//                       {frequency.label}
//                     </option>
//                   )
//                 )}
//               </SelectInput>

//               {salaryForm.payFrequency !== "W" && (
//                 <CurrencyInput
//                   label="Basic Salary"
//                   value={salaryForm.basic}
//                   error={errors.basic}
//                   disabled={isView}
//                   onChange={(value) =>
//                     handleSalaryChange("basic", value)
//                   }
//                 />
//               )}

//               {/* Salary Reference */}
//               <TextInput
//                 label="Salary Reference"
//                 value={salaryForm.salaryReference}
//                 error={errors.salaryReference}
//                 disabled
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "salaryReference",
//                     event.target.value
//                   )
//                 }
//               />

//               {/* Effective Date */}
//               <DateInput
//                 label="Effective Start Date"
//                 value={salaryForm.effectiveDate}
//                 error={errors.effectiveDate}
//                 disabled={isView}
//                 onChange={(value) =>
//                   handleSalaryChange(
//                     "effectiveDate", value
//                   )
//                 }
//               />

//               {/* End Date */}
//               <DateInput
//                 label="Effective End Date"
//                 value={salaryForm.endDate}
//                 error={errors.endDate}
//                 disabled={isView}
//                 onChange={(value) =>
//                   handleSalaryChange(
//                     "endDate", value
//                   )
//                 }
//               />

//               {/* Daily Rate */}
//               <CurrencyInput
//                 label="Daily Rate"
//                 value={salaryForm.dailyRate}
//                 error={errors.dailyRate}
//                 disabled={isView}
//                 onChange={(value) =>
//                   handleSalaryChange("dailyRate", value)
//                 }
//               />

//               {/* Remarks */}
//               <TextArea
//                 label="Remarks"
//                 value={salaryForm.remarks}
//                 error={errors.remarks}
//                 disabled={isView}
//                 rows={1}
//                 onChange={(event) =>
//                   handleSalaryChange(
//                     "remarks",
//                     event.target.value
//                   )
//                 }
//               />

//               {/* Previous Salary Records Section */}
//               {previousSalaries.length > 0 && (
//                 <div className="sm:col-span-2 mt-2">
//                   <div className="rounded-md border border-surface-200 bg-white overflow-hidden shadow-sm">
//                     <button
//                       type="button"
//                       onClick={() => setShowPreviousRecords(!showPreviousRecords)}
//                       className="w-full flex items-center justify-between px-4 py-3 bg-surface-50 hover:bg-surface-100 transition-colors focus:outline-none"
//                     >
//                       <span className="text-[13px] font-semibold text-surface-800">
//                         Previous Salary Records ({previousSalaries.length})
//                       </span>
//                       <svg
//                         className={`h-4 w-4 text-surface-500 transition-transform duration-200 ${
//                           showPreviousRecords ? "rotate-180" : ""
//                         }`}
//                         fill="none"
//                         viewBox="0 0 24 24"
//                         stroke="currentColor"
//                       >
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
//                       </svg>
//                     </button>

//                     {showPreviousRecords && (
//                       <div className="border-t border-surface-200 p-4 max-h-[350px] overflow-y-auto bg-surface-50/30 flex flex-col gap-4">
//                         {previousSalaries.map((prevSalary) => {
//                           const assignedComponents = salaryComponents.filter((comp) => {
//                             if (String(comp.employeeSalaryId) !== String(prevSalary.id)) {
//                               return false;
//                             }

//                             const payrollComponent = payrollComponents.find(
//                               (c) => String(c.id) === String(comp.componentId)
//                             );

//                             return (
//                               payrollComponent && !payrollComponent.basic && payrollComponent.type === "Earning"
//                             )
//                           });

//                           return (
//                             <div
//                               key={prevSalary.id}
//                               className="rounded-md border border-surface-200 bg-white p-4 shadow-sm"
//                             >
//                               <div className="flex items-center justify-between mb-3">
//                                 <span className="font-semibold text-surface-800 text-sm">
//                                   {prevSalary.salaryReference || "N/A"}
//                                 </span>
//                                 <span className="text-xs font-medium bg-surface-100 text-surface-600 px-2 py-1 rounded">
//                                   {prevSalary.effectiveDate ? toIsoDate(prevSalary.effectiveDate) : "N/A"} -{" "}
//                                   {prevSalary.endDate ? toIsoDate(prevSalary.endDate) : "Present"}
//                                 </span>
//                               </div>

//                               <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-xs text-surface-600">
//                                 <div className="flex justify-between">
//                                   <span>Basic Salary:</span>
//                                   <span className="font-medium text-surface-800">
//                                     {fmtMoney(prevSalary.basic)}
//                                   </span>
//                                 </div>
//                                 {/* <div className="flex justify-between">
//                                   <span>Gross Salary:</span>
//                                   <span className="font-medium text-surface-800">
//                                     {fmtMoney(prevSalary.grossSalary || 0)}
//                                   </span>
//                                 </div> */}
//                                 <div className="flex justify-between">
//                                   <span>Pay Freq:</span>
//                                   <span className="font-medium text-surface-800">
//                                     {prevSalary.payFrequency === "M"
//                                       ? "Monthly"
//                                       : prevSalary.payFrequency === "W"
//                                       ? "Weekly"
//                                       : prevSalary.payFrequency}
//                                   </span>
//                                 </div>
//                                 <div className="flex justify-between">
//                                   <span>Daily Rate:</span>
//                                   <span className="font-medium text-surface-800">
//                                     {fmtMoney(prevSalary.dailyRate || 0)}
//                                   </span>
//                                 </div>
//                               </div>

//                               {/* Salary Components Mapping */}
//                               <div className="mt-4 pt-3 border-t border-surface-100">
//                                 <span className="text-[10px] font-semibold text-surface-500 uppercase tracking-wider">
//                                   Assigned Components
//                                 </span>
//                                 {assignedComponents.length > 0 ? (
//                                   <div className="mt-2 flex flex-wrap gap-2">
//                                     {assignedComponents.map((comp) => {
//                                       // Look up the component name in the master payroll components list
//                                       const compDetails = payrollComponents.find(
//                                         (c) => String(c.id) === String(comp.componentId)
//                                       );
//                                       const displayName = compDetails
//                                         ? compDetails.name
//                                         : `Component ${comp.componentId}`;

//                                       return (
//                                         <span
//                                           key={comp.id}
//                                           className="inline-flex items-center rounded bg-primary-50 px-2 py-1 text-[11px] font-medium text-primary-700 ring-1 ring-inset ring-primary-600/20"
//                                         >
//                                           {displayName}: {fmtMoney(comp.amount)}
//                                         </span>
//                                       );
//                                     })}
//                                   </div>
//                                 ) : (
//                                   <p className="mt-1 text-[11px] text-surface-400 italic">
//                                     No components assigned
//                                   </p>
//                                 )}
//                               </div>
//                             </div>
//                           );
//                         })}
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               )}
//             </div>
//           </section>

//           {/* ────────────────────────────────────────────────────────── */}
//           {/* Salary Components                                         */}
//           {/* ────────────────────────────────────────────────────────── */}

//           <section className="border-t border-surface-200 pt-5">
//             <div className="mb-3 flex items-center justify-between gap-3">
//               <div>
//                 <h3 className={SECTION_TITLE_CLASS}>
//                   Salary Components
//                 </h3>

//                 <p className={SECTION_SUBTITLE_CLASS}>
//                   Add allowances, deductions and other salary components.
//                 </p>
//               </div>

//               {!isView && (
//                 <Button
//                   type="button"
//                   size="small"
//                   variant="outlined"
//                   startIcon={<Plus size={14} />}
//                   onClick={() =>
//                     setShowComponentForm((previous) => {
//                       const opening = !previous;

//                       if (opening && !editingComponentId) {
//                         const today = new Date();

//                         setEditingPendingIndex(null);

//                         setComponentForm({
//                           ...INITIAL_COMPONENT_FORM,
//                           effectiveDate: toIsoDate(today),
//                           endDate: toIsoDate(getLastDayOfThisMonth(today)),
//                         });
//                       }

//                       return opening;
//                     })
//                   }
//                   className="
//                     !min-w-0
//                     !border-primary-600
//                     !px-3
//                     !py-1.5
//                     !text-primary-600
//                   "
//                 >
//                   Add Component
//                 </Button>
//               )}
//             </div>

//             {/* Existing Components */}
//             {currentSalaryComponents.length === 0 &&
//             pendingComponents.length === 0 ? (
//               <div className="
//                 rounded-md
//                 border
//                 border-dashed
//                 border-surface-300
//                 bg-surface-50
//                 px-4
//                 py-5
//                 text-center
//               ">
//                 <p className="text-xs text-surface-500">
//                   No salary components assigned.
//                 </p>

//                 {!isView && (
//                   <p className="mt-1 text-[11px] text-surface-400">
//                     Click "Add Component" to assign one.
//                   </p>
//                 )}
//               </div>
//             ) : (
//               <div className="overflow-hidden rounded-md border border-surface-200">
//                 <div className="overflow-x-auto">
//                   <table className="w-full min-w-[620px] text-xs">
//                     <thead className="bg-surface-50">
//                       <tr>
//                         <th className="px-3 py-2 text-left font-medium text-surface-600">
//                           Component
//                         </th>

//                         <th className="px-3 py-2 text-right font-medium text-surface-600">
//                           Amount
//                         </th>

//                         <th className="px-3 py-2 text-center font-medium text-surface-600">
//                           Effective
//                         </th>

//                         <th className="px-3 py-2 text-center font-medium text-surface-600">
//                           End
//                         </th>

//                         <th className="px-3 py-2 text-center font-medium text-surface-600">
//                           Status
//                         </th>

//                         {!isView && (
//                           <th className="w-24 px-2 text-center font-medium text-surface-600">
//                             Actions
//                           </th>
//                         )}
//                       </tr>
//                     </thead>

//                     <tbody>
//                       {/* Existing saved components */}
//                       {currentSalaryComponents.map(
//                         (component) => (
//                           <tr
//                             key={`saved-${component.id}`}
//                             className="border-t border-surface-100"
//                           >
//                             <td className="px-3 py-2 font-medium text-surface-800">
//                               {component.componentName}
//                             </td>

//                             <td className="px-3 py-2 text-right tabular-nums text-surface-700">
//                               {fmtMoney(component.amount)}
//                             </td>

//                             <td className="px-3 py-2 text-center tabular-nums text-surface-600">
//                               {toIsoDate(
//                                 component.effectiveDate
//                               )}
//                             </td>

//                             <td className="px-3 py-2 text-center tabular-nums text-surface-600">
//                               {toIsoDate(
//                                 component.endDate
//                               )}
//                             </td>

//                             <td className="px-3 py-2 text-center">
//                               <StatusPill
//                                 label={
//                                   component.isActive
//                                     ? "Active"
//                                     : "Inactive"
//                                 }
//                               />
//                             </td>

//                             {!isView && (
//                               <td className="px-2">
//                                 <div className="flex items-center justify-center gap-1">
//                                   <button
//                                     type="button"
//                                     onClick={() =>
//                                       handleEditExistingComponent(component)
//                                     }
//                                     disabled={saving}
//                                     className="
//                                       inline-flex
//                                       h-7
//                                       items-center
//                                       justify-center
//                                       rounded
//                                       px-2
//                                       text-[11px]
//                                       font-medium
//                                       text-primary-600
//                                       transition-colors
//                                       hover:bg-primary-50
//                                       disabled:cursor-not-allowed
//                                       disabled:opacity-50
//                                     "
//                                     title="Edit component"
//                                   >
//                                     <Pencil size={13} />
//                                   </button>

//                                   {component.isActive !== false ? (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         handleToggleExistingComponentStatus(component, false)
//                                       }
//                                       disabled={saving}
//                                       className="
//                                         inline-flex
//                                         h-7
//                                         w-7
//                                         items-center
//                                         justify-center
//                                         rounded
//                                         text-gray-400
//                                         transition-colors
//                                         hover:bg-red-50
//                                         hover:text-red-600
//                                         disabled:cursor-not-allowed
//                                         disabled:opacity-50
//                                       "
//                                       title="Deactivate component"
//                                     >
//                                       <Trash2 size={13} />
//                                     </button>
//                                   ) : (
//                                     <button
//                                       type="button"
//                                       onClick={() =>
//                                         handleToggleExistingComponentStatus(component, true)
//                                       }
//                                       disabled={saving}
//                                       className="
//                                         inline-flex
//                                         h-7
//                                         w-7
//                                         items-center
//                                         justify-center
//                                         rounded
//                                         text-emerald-400
//                                         transition-colors
//                                         hover:bg-emerald-50
//                                         hover:text-emerald-600
//                                         disabled:cursor-not-allowed
//                                         disabled:opacity-50
//                                       "
//                                       title="Reactivate component"
//                                     >
//                                       <RotateCcw size={13} />
//                                     </button>
//                                   )}

//                                 </div>
//                               </td>
//                             )}
//                           </tr>
//                         )
//                       )}

//                       {/* Pending components */}
//                       {pendingComponents.map(
//                         (component, index) => {
//                           const componentName =
//                             payrollComponents.find(
//                               (item) =>
//                                 String(item.id) ===
//                                 String(
//                                   component.componentId
//                                 )
//                             )?.name ??
//                             "-";

//                           return (
//                             <tr
//                               key={`pending-${index}`}
//                               className="border-t border-primary-100 bg-primary-50/40"
//                             >
//                               <td className="px-3 py-2 font-medium text-surface-800">
//                                 {componentName}
//                                 <span className="ml-2 rounded bg-primary-100 px-1.5 py-0.5 text-[9px] font-medium text-primary-700">
//                                   New
//                                 </span>
//                               </td>

//                               <td className="px-3 py-2 text-right tabular-nums text-surface-700">
//                                 {fmtMoney(
//                                   component.amount
//                                 )}
//                               </td>

//                               <td className="px-3 py-2 text-center tabular-nums text-surface-600">
//                                 {toIsoDate(
//                                   component.effectiveDate
//                                 )}
//                               </td>

//                               <td className="px-3 py-2 text-center tabular-nums text-surface-600">
//                                 {toIsoDate(
//                                   component.endDate
//                                 )}
//                               </td>

//                               <td className="px-3 py-2 text-center">
//                                 <StatusPill label="Active" />
//                               </td>

//                               <td className="px-2 text-center">
//                                 <div className="flex items-center justify-center gap-1">
//                                   <button
//                                     type="button"
//                                     onClick={() => handleEditPendingComponent(index)}
//                                     disabled={saving}
//                                     className="inline-flex h-7 items-center justify-center rounded px-2 text-[11px] font-medium text-primary-600 transition-colors hover:bg-primary-50 disabled:cursor-not-allowed disabled:opacity-50"
//                                     title="Edit component"
//                                   >
//                                     <Pencil size={13} />
//                                   </button>
//                                   <button
//                                     type="button"
//                                     onClick={() => handleRemovePendingComponent(index)}
//                                     className="inline-flex h-7 w-7 items-center justify-center rounded text-gray-400 transition-colors hover:bg-red-50 hover:text-red-600"
//                                     title="Remove"
//                                   >
//                                     <Trash2 size={13} />
//                                   </button>
//                                 </div>
//                               </td>
//                             </tr>
//                           );
//                         }
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             )}

//             {/* Add Component Inline Form */}
//             {showComponentForm && !isView && (
//               <div className="
//                 mt-3
//                 rounded-md
//                 border
//                 border-surface-200
//                 bg-surface-50
//                 p-3
//               ">
//                 <div className="mb-3 flex items-center justify-between">
//                   <div>
//                     <h4 className="text-xs font-semibold text-surface-800">
//                       {editingComponentId || editingPendingIndex !== null ? "Edit Salary Component" : "New Salary Component"}
//                     </h4>

//                     <p className="text-[11px] text-surface-500">
//                       {editingComponentId ? "Update the component details." : "Add the component details before saving."}
//                     </p>
//                   </div>

//                   <button
//                     type="button"
//                     onClick={resetComponentForm}
//                     className="
//                       inline-flex
//                       h-6
//                       w-6
//                       items-center
//                       justify-center
//                       rounded
//                       text-surface-400
//                       hover:bg-white
//                       hover:text-surface-700
//                     "
//                     title="Close"
//                   >
//                     <X size={14} />
//                   </button>
//                 </div>

//                 <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">

//                   {/* Component */}
//                   <SelectInput
//                     label="Salary Component"
//                     value={
//                       componentForm.componentId
//                     }
//                     error={componentErrors.componentId}
//                     onChange={(event) => {
//                       const selectedId = event.target.value;
//                       handleComponentChange("componentId", event.target.value);

//                       if (selectedId) {
//                         const selectedComp = payrollComponents.find((c) => String(c.id) === String(selectedId));

//                         if (selectedComp && selectedComp.defaultAmount > 0) {
//                           const formattedDefault = maskCurrencyInput(Number(selectedComp.defaultAmount).toFixed(2));
//                           handleComponentChange("amount", formattedDefault)
//                         } else {
//                           handleComponentChange("amount", "");
//                         }
//                       } else {
//                         handleComponentChange("amount", "");
//                       }
//                     }}
//                   >
//                     <option value="">
//                       Select Salary Component
//                     </option>

//                     {payrollComponents
//                       .filter((component) => !component.basic && component.type === "Earning")
//                       .map(
//                         (component) => (
//                           <option
//                             key={component.id}
//                             value={component.id}
//                           >
//                             {component.name}
//                           </option>
//                         )
//                       )
//                     }
//                   </SelectInput>

//                   {/* Amount */}
//                   <CurrencyInput
//                     label="Amount"
//                     value={componentForm.amount}
//                     error={componentErrors.amount}
//                     onChange={(value) =>
//                       handleComponentChange("amount", value)
//                     }
//                   />

//                   {/* Effective */}
//                   <DateInput
//                     label="Effective Start Date"
//                     value={
//                       componentForm.effectiveDate
//                     }
//                     error={componentErrors.effectiveDate}
//                     onChange={(value) =>
//                       handleComponentChange(
//                         "effectiveDate", value
//                       )
//                     }
//                   />

//                   {/* End */}
//                   <DateInput
//                     label="Effective End Date"
//                     value={componentForm.endDate}
//                     error={componentErrors.endDate}
//                     onChange={(value) =>
//                       handleComponentChange(
//                         "endDate", value
//                       )
//                     }
//                   />

//                   {/* Remarks */}
//                   <TextArea
//                     label="Remarks"
//                     value={componentForm.remarks}
//                     rows={1}
//                     className="sm:col-span-2"
//                     onChange={(event) =>
//                       handleComponentChange(
//                         "remarks",
//                         event.target.value
//                       )
//                     }
//                   />
//                 </div>

//                 <div className="mt-3 flex justify-end gap-2">
//                   <Button
//                     type="button"
//                     size="small"
//                     onClick={resetComponentForm}
//                     className="!px-3 !py-1.5 !text-xs !text-surface-600"
//                   >
//                     Cancel
//                   </Button>

//                   <Button
//                     type="button"
//                     size="small"
//                     variant="contained"
//                     startIcon={editingComponentId || editingPendingIndex !== null ? null : <Plus size={13} />}
//                     onClick={
//                       editingComponentId ? handleUpdateExistingComponent : handleAddPendingComponent
//                     }
//                     disabled={saving}
//                     className="
//                       !bg-primary-600
//                       !px-3
//                       !py-1.5
//                       !text-xs
//                       hover:!bg-primary-700
//                     "
//                   >
//                     {editingComponentId || editingPendingIndex !== null ? "Update" : "Add"}
//                   </Button>
//                 </div>
//               </div>
//             )}
//           </section>
//         </div>
//       </DialogContent>

//       {/* ──────────────────────────────────────────────────────────────── */}
//       {/* Footer                                                          */}
//       {/* ──────────────────────────────────────────────────────────────── */}

//       <DialogActions className="!border-t !border-surface-100 !px-6 !py-3">
//         <Button
//           type="button"
//           onClick={onClose}
//           disabled={saving}
//           className="!px-3 !text-sm !text-primary-600"
//         >
//           {isView ? "CLOSE" : "CANCEL"}
//         </Button>

//         {!isView && (
//           <Button
//             type="button"
//             variant="contained"
//             onClick={handleSave}
//             disabled={saving || isEditingComponent}
//             className={`
//               !bg-primary-600
//               !px-4
//               !text-sm
//               hover:!bg-primary-700
//             `}
//           >
//             {saving
//               ? "SAVING..."
//               : isEdit
//                 ? "UPDATE"
//                 : "SAVE"}
//           </Button>
//         )}
//       </DialogActions>
//     </Dialog>
//   );
// };

// export default EmployeeSalaryDialog;

// ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
// ----------------------- VERSTION 3
// ---------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Pencil, Plus, RotateCcw, Trash2, X, Loader2, Calendar, Banknote } from "lucide-react";
import { toast } from "react-toastify";

import { fmtMoney } from "../../utils/payrollFormat";
import { toIsoDate } from "../../utils/dateFormat";
import { StatusPill } from "../Table/Table";
import IsoDateInput from "../common/Isodateinput";
import { fetchOTRateHistory } from "../../store/slices/overtimeSlice";
import SearchableSelect from "../common/SearchableSelect";

/* ────────────────────────────────────────────────────────────────────────── */
/* Constants                                                                  */
/* ────────────────────────────────────────────────────────────────────────── */

const INITIAL_SALARY_FORM = {
  employeeId: "",
  salaryReference: "",
  basic: "",
  effectiveDate: "",
  endDate: "",
  payFrequency: "M",
  grossSalary: 0,
  workingDays: null,
  dailyRate: "",
  isCurrent: true,
  isActive: true,
  remarks: "",
};

const INITIAL_COMPONENT_FORM = {
  componentId: "",
  amount: "",
  percentage: 0,
  effectiveDate: "",
  endDate: "",
  isActive: true,
  remarks: "",
};

const PAY_FREQUENCIES = [
  { value: "M", label: "Monthly" },
  { value: "W", label: "Weekly" },
];

const getOneYearFromToday = (date) => {
  const d = new Date(date);
  d.setFullYear(d.getFullYear() + 1);
  return d;
};

const getLastDayOfThisMonth = (date) => {
  const d = new Date(date);
  return new Date(d.getFullYear(), d.getMonth() + 1, 0);
};

const maskCurrencyInput = (rawValue) => {
  const digits = String(rawValue ?? "").replace(/\D/g, "");
  if (!digits) return "";

  const padded = digits.padStart(3, "0");
  const cents = padded.slice(-2);

  const wholeDigits = padded.slice(0, -2).replace(/^0+(?=\d)/, "");
  const whole = Number(wholeDigits || "0").toLocaleString("en-US");

  return `${whole}.${cents}`;
};

const parseCurrency = (value) => {
  if (value === "" || value === null) return 0;
  const n = Number(String(value).replace(/,/g, ""));
  return Number.isNaN(n) ? 0 : n;
};

/* ────────────────────────────────────────────────────────────────────────── */
/* Styles                                                                     */
/* ────────────────────────────────────────────────────────────────────────── */

const INPUT_CLASS = `
  w-full h-10
  rounded-lg
  border border-surface-200
  bg-surface-50/60
  px-3
  text-sm text-surface-800
  outline-none
  transition-all
  focus:bg-white
  focus:border-primary-500
  focus:ring-2 focus:ring-primary-500/10
`;

const DISABLED_INPUT_CLASS = `
  bg-gray-100
  text-gray-400
  border-gray-200
  opacity-60
  cursor-not-allowed
`;

const LABEL_CLASS = `
  absolute
  left-2.5
  top-0
  -translate-y-1/2
  bg-white
  px-1.5
  text-[11px]
  font-medium
  text-surface-500
  pointer-events-none
  z-10
`;

const SECTION_TITLE_CLASS = "text-sm font-semibold text-surface-900";
const SECTION_SUBTITLE_CLASS = "mt-0.5 text-xs text-surface-500";

/* ────────────────────────────────────────────────────────────────────────── */
/* Small Form Components                                                      */
/* ────────────────────────────────────────────────────────────────────────── */

function Field({ label, children, className = "", error = "" }) {
  return (
    <div className={`relative ${className}`}>
      <label className={LABEL_CLASS}>{label}</label>
      {children}
      {error && (
        <p className="mt-1 flex items-start gap-1 text-[11px] text-red-500">
          {error}
        </p>
      )}
    </div>
  );
}

function TextInput({
  label,
  value,
  onChange,
  type = "text",
  disabled = false,
  placeholder = "",
  min,
  step,
  error = "",
}) {
  return (
    <Field label={label} error={error}>
      <input
        type={type}
        value={value ?? ""}
        onChange={onChange}
        disabled={disabled}
        placeholder={placeholder}
        min={min}
        step={step}
        className={`${INPUT_CLASS} ${disabled ? DISABLED_INPUT_CLASS : ""} ${
          error ? "border-red-400 focus:border-red-500 focus:ring-red-500/10" : ""
        }`}
      />
    </Field>
  );
}

function CurrencyInput({
  label,
  value,
  onChange,
  disabled = false,
  error = "",
}) {
  return (
    <Field label={label} error={error}>
      <input
        type="text"
        inputMode="decimal"
        value={value ?? ""}
        disabled={disabled}
        onChange={(event) => onChange(maskCurrencyInput(event.target.value))}
        className={`${INPUT_CLASS} ${disabled ? DISABLED_INPUT_CLASS : ""} ${
          error ? "border-red-400 focus:border-red-500 focus:ring-red-500/10" : ""
        }`}
      />
    </Field>
  );
}

function DateInput({ label, value, onChange, disabled = false, error = "" }) {
  return (
    <Field label={label} error={error}>
      <IsoDateInput
        value={value ?? ""}
        onChange={onChange}
        disabled={disabled}
        className={`${INPUT_CLASS} appearance-none ${
          disabled ? DISABLED_INPUT_CLASS : ""
        } ${error ? "border-red-400 focus:border-red-500 focus:ring-red-500/10" : ""}`}
      />
    </Field>
  );
}

function SelectInput({
  label,
  value,
  onChange,
  children,
  disabled = false,
  error = "",
}) {
  return (
    <Field label={label} error={error}>
      <select
        value={value ?? ""}
        onChange={onChange}
        disabled={disabled}
        className={`${INPUT_CLASS} appearance-auto cursor-pointer ${
          disabled ? DISABLED_INPUT_CLASS : ""
        } ${error ? "border-red-400 focus:border-red-500 focus:ring-red-500/10" : ""}`}
      >
        {children}
      </select>
    </Field>
  );
}

function TextArea({
  label,
  value,
  onChange,
  disabled = false,
  rows = 2,
  error = "",
  className = "",
}) {
  return (
    <Field label={label} error={error} className={className}>
      <textarea
        value={value ?? ""}
        onChange={onChange}
        disabled={disabled}
        rows={rows}
        className={`w-full rounded-lg border border-surface-200 bg-surface-50/60 px-3 py-2.5 text-sm text-surface-800 outline-none transition-all resize-none focus:bg-white focus:border-primary-500 focus:ring-2 focus:ring-primary-500/10 ${
          disabled ? DISABLED_INPUT_CLASS : ""
        } ${error ? "border-red-400 focus:border-red-500 focus:ring-red-500/10" : ""}`}
      />
    </Field>
  );
}

/* ────────────────────────────────────────────────────────────────────────── */
/* Main Component                                                             */
/* ────────────────────────────────────────────────────────────────────────── */

const EmployeeSalaryDialog = ({
  open,
  onClose,
  onSave,
  onSaveComponent,
  onExited,

  employees = [],
  employeeSalaries = [],
  salary = null,
  mode = "add",

  salaryComponents = [],
  payrollComponents = [],
}) => {
  const isAdd = mode === "add";
  const isEdit = mode === "edit";
  const isView = mode === "view";

  const dispatch = useDispatch();
  const { otRateHistory, otRateHistoryLoading } = useSelector(
    (state) => state.overtime,
  );

  const [activeTab, setActiveTab] = useState(0);
  const [salaryForm, setSalaryForm] = useState(INITIAL_SALARY_FORM);
  const [componentForm, setComponentForm] = useState(INITIAL_COMPONENT_FORM);
  const [showComponentForm, setShowComponentForm] = useState(false);
  const [pendingComponents, setPendingComponents] = useState([]);
  const [editingPendingIndex, setEditingPendingIndex] = useState(null);
  const [editingComponentId, setEditingComponentId] = useState(null);
  const [saving, setSaving] = useState(false);
  const [errors, setErrors] = useState({});
  const [componentErrors, setComponentErrors] = useState({});
  const [salaryReferenceAuto, setSalaryReferenceAuto] = useState(true);

  const isEditingComponent =
    showComponentForm &&
    (Boolean(editingComponentId) || editingPendingIndex !== null);

  /* Reset form helpers */
  const resetAll = useCallback(() => {
    setSalaryForm(INITIAL_SALARY_FORM);
    setComponentForm(INITIAL_COMPONENT_FORM);
    setPendingComponents([]);
    setShowComponentForm(false);
    setErrors({});
    setComponentErrors({});
    setSaving(false);
    setSalaryReferenceAuto(true);
    setActiveTab(0);
  }, []);

  /* ──────────────────────────────────────────────────────────────────────── */
  /* Initialize Salary Form                                                   */
  /* ──────────────────────────────────────────────────────────────────────── */

  useEffect(() => {
    if (!open) {
      resetAll();
      onExited?.();
      return;
    }

    setErrors({});
    setShowComponentForm(false);
    setComponentForm(INITIAL_COMPONENT_FORM);
    setPendingComponents([]);
    setEditingComponentId(null);
    setEditingPendingIndex(null);
    setComponentErrors({});
    setSalaryReferenceAuto(true);
    setActiveTab(0);

    if (salary && (isEdit || isView)) {
      setSalaryForm({
        employeeId: salary.employeeId ?? "",
        salaryReference: salary.salaryReference ?? "",
        effectiveDate: toIsoDate(salary.effectiveDate) ?? "",
        endDate: toIsoDate(salary.endDate) ?? "",
        payFrequency:
          salary.payFrequency === "Monthly"
            ? "M"
            : salary.payFrequency === "Weekly"
              ? "W"
              : (salary.payFrequency ?? "M"),
        grossSalary: salary.grossSalary ?? "",
        workingDays: salary.workingDays ?? "",
        // basic:
        //   salary.basic !== null
        //     ? maskCurrencyInput(String(Math.round(Number(salary.basic) * 100)))
        //     : "",
        basic:
          salary.payFrequency === "Weekly" || salary.payFrequency === "W"
            ? maskCurrencyInput("000")
            : salary.basic !== null
              ? maskCurrencyInput(String(Math.round(Number(salary.basic) * 100)))
              : "",
        dailyRate:
          salary.dailyRate !== null
            ? maskCurrencyInput(
                String(Math.round(Number(salary.dailyRate) * 100)),
              )
            : "",
        isCurrent: salary.isCurrent ?? true,
        isActive: salary.isActive ?? true,
        remarks: salary.remarks ?? "",
      });
      return;
    }

    const today = new Date();
    setSalaryForm({
      ...INITIAL_SALARY_FORM,
      effectiveDate: toIsoDate(today),
      endDate: toIsoDate(getOneYearFromToday(today)),
    });
    setSalaryReferenceAuto(true);
  }, [open, salary, isEdit, isView, resetAll, onExited]);

  /* Keyboard shortcut (Escape to close) */
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "Escape" && open && !saving) {
        onClose?.();
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [open, saving, onClose]);

  /* ──────────────────────────────────────────────────────────────────────── */
  /* Employee Name & Previous Salaries Memo                                   */
  /* ──────────────────────────────────────────────────────────────────────── */

  const selectedEmployee = useMemo(() => {
    return employees.find(
      (employee) =>
        String(employee.HED_EMPLOYEE_ID) === String(salaryForm.employeeId),
    );
  }, [employees, salaryForm.employeeId]);

  const isCategoryC = selectedEmployee?.HEC_CATEGORY_CODE === "C";
  const isCategoryE = selectedEmployee?.HEC_CATEGORY_CODE === "E";

  const previousSalaries = useMemo(() => {
    if (!salaryForm.employeeId) return [];

    // Reference date: current salary effectiveDate or the form's effectiveDate
    const currentEffective = salary?.effectiveDate || salaryForm.effectiveDate;
    const currentEffectiveTime = currentEffective ? new Date(currentEffective).getTime() : Infinity;

    const empSalaries = employeeSalaries.filter((s) => {
      if (String(s.employeeId) !== String(salaryForm.employeeId)) return false;
      if (String(s.id) === String(salary?.id)) return false;
      if (!s.effectiveDate) return false;

      // Only include records that took effect strictly before the current one
      return new Date(s.effectiveDate).getTime() < currentEffectiveTime;
    });

    return empSalaries.sort(
      (a, b) => new Date(b.effectiveDate) - new Date(a.effectiveDate),
    );
  }, [salaryForm.employeeId, salaryForm.effectiveDate, employeeSalaries, salary?.id, salary?.effectiveDate]);

  /* ──────────────────────────────────────────────────────────────────────── */
  /* Overtime Tab Fetching                                                    */
  /* ──────────────────────────────────────────────────────────────────────── */

  useEffect(() => {
    if (activeTab === 1 && selectedEmployee?.HED_SERVICE_NO) {
      dispatch(fetchOTRateHistory(selectedEmployee.HED_SERVICE_NO));
    }
  }, [activeTab, selectedEmployee, dispatch]);

  /* ──────────────────────────────────────────────────────────────────────── */
  /* Components belonging to current salary                                   */
  /* ──────────────────────────────────────────────────────────────────────── */

  const currentSalaryComponents = useMemo(() => {
    if (!salary?.id) return [];

    return salaryComponents
      .filter(
        (component) => String(component.employeeSalaryId) === String(salary.id),
      )
      .filter((component) => {
        const payrollComponent = payrollComponents.find(
          (pc) => String(pc.id) === String(component.componentId),
        );
        return (
          payrollComponent &&
          !payrollComponent.basic &&
          payrollComponent.type === "Earning"
        );
      })
      .map((component) => {
        const payrollComponent = payrollComponents.find(
          (pc) => String(pc.id) === String(component.componentId),
        );
        return {
          ...component,
          componentName: payrollComponent?.name ?? "-",
          code: payrollComponent?.code,
        };
      });
  }, [salary, salaryComponents, payrollComponents]);

  /* ──────────────────────────────────────────────────────────────────────── */
  /* Period Overlap Check                                                     */
  /* ──────────────────────────────────────────────────────────────────────── */

  const isEmployeeAssigned = useCallback(
    (employeeId) => {
      if (!salaryForm.effectiveDate || !salaryForm.endDate) return false;

      const newStart = new Date(salaryForm.effectiveDate);
      const newEnd = new Date(salaryForm.endDate);

      return employeeSalaries.some((salaryRecord) => {
        if (isEdit && String(salaryRecord.id) === String(salary?.id)) {
          return false;
        }
        if (String(salaryRecord.employeeId) !== String(employeeId)) {
          return false;
        }
        if (!salaryRecord.effectiveDate || !salaryRecord.endDate) {
          return false;
        }

        const existingStart = new Date(salaryRecord.effectiveDate);
        const existingEnd = new Date(salaryRecord.endDate);

        return newStart <= existingEnd && newEnd >= existingStart;
      });
    },
    [
      salaryForm.effectiveDate,
      salaryForm.endDate,
      employeeSalaries,
      isEdit,
      salary?.id,
    ],
  );

  const generateSalaryReference = (employee, existingRefs = []) => {
    if (!employee) return "";
    const base = `SAL-${employee.HED_SERVICE_NO}-${Date.now().toString().slice(-5)}`;
    let candidate = base;
    let suffix = 1;
    while (existingRefs.includes(candidate)) {
      candidate = `${base}-${suffix++}`;
    }
    return candidate;
  };

  /* ──────────────────────────────────────────────────────────────────────── */
  /* Form Handlers                                                            */
  /* ──────────────────────────────────────────────────────────────────────── */

  // Check if the component is auto-derived
  const selectedPayrollComponent = useMemo(() => {
    if (!componentForm.componentId) return null;
    return payrollComponents.find(
      (c) => String(c.id) === String(componentForm.componentId)
    );
  }, [componentForm.componentId, payrollComponents]);

  const isAttendanceAllowance = useCallback((componentId) => {
    const comp = payrollComponents.find((c) => String(c.id || c.HPC_COMPONENT_ID) === String(componentId));
    return (comp?.code || comp?.HPC_COMPONENT_CODE)?.toUpperCase() === "ATTEND-ALLOW";
  }, [payrollComponents]);

  const isOtPay = useCallback((componentId) => {
    const comp = payrollComponents.find((c) => String(c.id || c.HPC_COMPONENT_ID) === String(componentId));
    return (comp?.code || comp?.HPC_COMPONENT_CODE)?.toUpperCase() === "OT-PAY";
  }, [payrollComponents]);

  const isExtraDay = useCallback((componentId) => {
    const comp = payrollComponents.find((c) => String(c.id || c.HPC_COMPONENT_ID) === String(componentId));
    return (comp?.code || comp?.HPC_COMPONENT_CODE)?.toUpperCase() === "EXTRA-DAY";
  }, [payrollComponents]);

  // const isAutoCalculatedComponent = useMemo(() => {
  //   const code = (selectedPayrollComponent?.code || selectedPayrollComponent?.HPC_COMPONENT_CODE)?.toUpperCase();
  //   return code === "ATTEND-ALLOW" || code === "OT-PAY" || code === "EXTRA-DAY";
  // }, [selectedPayrollComponent]);

  const isAmountLocked = useMemo(() => {
    const code = (selectedPayrollComponent?.code || selectedPayrollComponent?.HPC_COMPONENT_CODE)?.toUpperCase();
    return code === "ATTEND-ALLOW" || code === "OT-PAY";
  }, [selectedPayrollComponent]);

  // Helper to calculate Extra Day rate: (Basic + sum of all active Fixed earnings) / 30
  const computeExtraDayAmount = useCallback((overridePending = null) => {
    const basicVal = isCategoryE || salaryForm.payFrequency === "W" ? 0 : parseCurrency(salaryForm.basic);
    let totalFixed = basicVal;

    // 1. Saved components
    currentSalaryComponents.forEach((comp) => {
      if (comp.isActive === false) return;
      const pc = payrollComponents.find((p) => String(p.id || p.HPC_COMPONENT_ID) === String(comp.componentId));
      const isFixed = pc?.earningCategory === "F" || pc?.HPC_EARNING_CATEGORY === "F";
      const code = (pc?.code || pc?.HPC_COMPONENT_CODE)?.toUpperCase();
      if (isFixed && code !== "EXTRA-DAY") {
        totalFixed += Number(comp.amount || comp.componentAmount || 0);
      }
    });

    // 2. Pending components
    const pendingList = overridePending || pendingComponents;
    pendingList.forEach((comp, idx) => {
      if (comp.isActive === false) return;
      if (editingPendingIndex !== null && idx === editingPendingIndex && !overridePending) return;
      const pc = payrollComponents.find((p) => String(p.id || p.HPC_COMPONENT_ID) === String(comp.componentId));
      const isFixed = pc?.earningCategory === "F" || pc?.HPC_EARNING_CATEGORY === "F";
      const code = (pc?.code || pc?.HPC_COMPONENT_CODE)?.toUpperCase();
      if (isFixed && code !== "EXTRA-DAY") {
        totalFixed += Number(comp.amount || 0);
      }
    });

    return (totalFixed / 30).toFixed(2);
  }, [
    isCategoryE,
    salaryForm.payFrequency,
    salaryForm.basic,
    currentSalaryComponents,
    pendingComponents,
    editingPendingIndex,
    payrollComponents,
  ]);

  const handleSalaryChange = (key, value) => {
    if (isView) return;

    let salaryReference;

    // if (key === "employeeId" && isAdd && salaryReferenceAuto) {
    //   const employee = employees.find(
    //     (e) => String(e.HED_EMPLOYEE_ID) === String(value),
    //   );
    //   const existingRefs = employeeSalaries.map((s) => s.salaryReference);
    //   salaryReference = generateSalaryReference(employee, existingRefs);
    // }

    // if (key === "salaryReference") {
    //   setSalaryReferenceAuto(false);
    // }

    // setSalaryForm((previous) => ({
    //   ...previous,
    //   [key]: value,
    //   ...(salaryReference !== undefined ? { salaryReference } : {}),
    //   ...(key === "payFrequency" && value === "W" ? { basic: maskCurrencyInput("000") } : {}),
    // }));

    let extraFields = {};

    if (key === "employeeId") {
      const emp = employees.find(
        (e) => String(e.HED_EMPLOYEE_ID) === String(value),
      );
      if (isAdd && salaryReferenceAuto) {
        const existingRefs = employeeSalaries.map((s) => s.salaryReference);
        salaryReference = generateSalaryReference(emp, existingRefs);
      }
      if (emp?.HEC_CATEGORY_CODE === "C") {
        extraFields.payFrequency = "M";
      } else if (emp?.HEC_CATEGORY_CODE === "E") {
        extraFields.basic = maskCurrencyInput("000");
      }
    }

    if (key === "salaryReference") {
      setSalaryReferenceAuto(false);
    }

    setSalaryForm((previous) => ({
      ...previous,
      [key]: value,
      ...extraFields,
      ...(salaryReference !== undefined ? { salaryReference } : {}),
      ...(key === "payFrequency" && (value === "W" || isCategoryE)
        ? { basic: maskCurrencyInput("000") }
        : {}),
    }));

    // If Daily Rate changes while editing/adding ATTEND-ALLOW, update its amount automatically
    if (key === "dailyRate" && selectedPayrollComponent?.code?.toUpperCase() === "ATTEND-ALLOW") {
      setComponentForm((prev) => ({
        ...prev,
        amount: value || "",
      }));
    }

    setErrors((prev) => {
      if (!prev[key]) return prev;
      const next = { ...prev };
      delete next[key];
      if (key === "payFrequency" && value === "W") delete next.basic;
      return next;
    });
  };

  const handleComponentChange = (key, value) => {
    if (isView) return;

    setComponentForm((previous) => ({
      ...previous,
      [key]: value,
    }));

    setComponentErrors((prev) => {
      if (!prev[key]) return prev;
      const next = { ...prev };
      delete next[key];
      return next;
    });
  };

  const resetComponentForm = () => {
    setComponentForm(INITIAL_COMPONENT_FORM);
    setEditingComponentId(null);
    setEditingPendingIndex(null);
    setShowComponentForm(false);
    setComponentErrors({});
  };

  const handleEditPendingComponent = (index) => {
    if (isView) return;

    const comp = pendingComponents[index];
    setEditingPendingIndex(index);
    setEditingComponentId(null);

    setComponentForm({
      componentId: comp.componentId ?? "",
      // amount:
      //   comp.amount != null
      //     ? maskCurrencyInput(String(Math.round(Number(comp.amount) * 100)))
      //     : "",

      // amount: isAttendanceAllowance(comp.componentId)
      //   ? (salaryForm.dailyRate || "")
      //   : isOtPay(comp.componentId) 
      //     ? (selectedEmployee?.HED_OT_RATE != null ? maskCurrencyInput(Number(selectedEmployee.HED_OT_RATE).toFixed(2)) : "")
      //     : isExtraDay(comp.componentId)
      //       ? maskCurrencyInput(computeExtraDayAmount())
      //       : comp.amount != null
      //         ? maskCurrencyInput(String(Math.round(Number(comp.amount) * 100)))
      //         : "",

      amount: isAttendanceAllowance(comp.componentId)
      ? (salaryForm.dailyRate || "")
      : isOtPay(comp.componentId) 
        ? (selectedEmployee?.HED_OT_RATE != null ? maskCurrencyInput(Number(selectedEmployee.HED_OT_RATE).toFixed(2)) : "")
        : comp.amount != null && comp.amount !== ""
          ? maskCurrencyInput(String(Math.round(Number(comp.amount) * 100)))
          : isExtraDay(comp.componentId)
            ? maskCurrencyInput(computeExtraDayAmount())
            : "",

      percentage: comp.percentage ?? 0,
      effectiveDate: comp.effectiveDate ?? "",
      endDate: comp.endDate ?? "",
      isActive: comp.isActive ?? true,
      remarks: comp.remarks ?? "",
    });

    setShowComponentForm(true);
  };

  const handleEditExistingComponent = (component) => {
    if (isView) return;

    setEditingComponentId(component.id);

    setComponentForm({
      employeeSalaryComponentId:
        component.employeeSalaryComponentId ?? component.id,
      componentId: component.componentId ?? "",
      // amount: isAttendanceAllowance(component.componentId)
      //   ? (salaryForm.dailyRate || "")
      //   : isOtPay(component.componentId)
      //     ? (selectedEmployee?.HED_OT_RATE != null ? maskCurrencyInput(Number(selectedEmployee.HED_OT_RATE).toFixed(2)) : "")
      //     : isExtraDay(component.componentId)
      //       ? maskCurrencyInput(computeExtraDayAmount())
      //       : component.amount != null
      //         ? maskCurrencyInput(String(Math.round(Number(component.amount) * 100)))
      //         : component.componentAmount != null
      //           ? maskCurrencyInput(String(Math.round(Number(component.componentAmount) * 100)))
      //           : "",
      amount: isAttendanceAllowance(component.componentId)
      ? (salaryForm.dailyRate || "")
      : isOtPay(component.componentId)
        ? (selectedEmployee?.HED_OT_RATE != null ? maskCurrencyInput(Number(selectedEmployee.HED_OT_RATE).toFixed(2)) : "")
        : component.amount != null && component.amount !== ""
          ? maskCurrencyInput(String(Math.round(Number(component.amount) * 100)))
          : component.componentAmount != null && component.componentAmount !== ""
            ? maskCurrencyInput(String(Math.round(Number(component.componentAmount) * 100)))
            : isExtraDay(component.componentId)
              ? maskCurrencyInput(computeExtraDayAmount())
              : "",
      percentage: component.percentage ?? component.componentPercentage ?? 0,
      effectiveDate: toIsoDate(component.effectiveDate) ?? "",
      endDate: toIsoDate(component.endDate) ?? "",
      isActive: component.isActive ?? true,
      remarks: component.remarks ?? "",
    });

    setShowComponentForm(true);
  };

  const handleAddPendingComponent = () => {
    const validationErrors = {};

    if (!componentForm.componentId) {
      validationErrors.componentId = "Please select a salary component.";
    }

    const isZeroAmount = isAttendanceAllowance(componentForm.componentId) || isOtPay(componentForm.componentId);

    if (
      !isZeroAmount &&
      (componentForm.amount === "" || parseCurrency(componentForm.amount) < 0)
    ) {
      validationErrors.amount = "Please enter a valid amount.";
    }

    if (!componentForm.effectiveDate) {
      validationErrors.effectiveDate =
        "Please select the component effective start date.";
    }

    if (!componentForm.endDate) {
      validationErrors.endDate = "Please select the component end date.";
    }

    if (
      componentForm.effectiveDate &&
      componentForm.endDate &&
      new Date(componentForm.effectiveDate) > new Date(componentForm.endDate)
    ) {
      validationErrors.endDate =
        "Component end date cannot be before the effective date.";
    }

    const duplicate = pendingComponents.some(
      (component, idx) =>
        idx !== editingPendingIndex &&
        String(component.componentId) === String(componentForm.componentId),
    );

    if (duplicate) {
      validationErrors.componentId =
        "This salary component has already been added.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setComponentErrors(validationErrors);
      return;
    }

    const formattedItem = {
      ...componentForm,
      amount: isZeroAmount ? 0 : (componentForm.amount === "" ? 0 : parseCurrency(componentForm.amount)),
      percentage: Number(componentForm.percentage || 0),
      isActive: true,
    };

    // if (editingPendingIndex !== null) {
    //   setPendingComponents((previous) =>
    //     previous.map((item, idx) =>
    //       idx === editingPendingIndex ? formattedItem : item,
    //     ),
    //   );
    // } else {
    //   setPendingComponents((previous) => [...previous, formattedItem]);
    // }

    // resetComponentForm();

    // setPendingComponents((previous) => {
    //   let nextList;
    //   if (editingPendingIndex !== null) {
    //     nextList = previous.map((item, idx) =>
    //       idx === editingPendingIndex ? formattedItem : item,
    //     );
    //   } else {
    //     nextList = [...previous, formattedItem];
    //   }

    //   // If any pending component is EXTRA-DAY and we just added/updated a fixed component, recalculate it
    //   const hasPendingExtraDay = nextList.some((item) => isExtraDay(item.componentId));
    //   if (hasPendingExtraDay) {
    //     const recalculatedExtraDay = Number(computeExtraDayAmount(nextList));
    //     nextList = nextList.map((item) =>
    //       isExtraDay(item.componentId)
    //         ? { ...item, amount: recalculatedExtraDay }
    //         : item,
    //     );
    //   }

    //   return nextList;
    // });

    setPendingComponents((previous) => {
      if (editingPendingIndex !== null) {
        return previous.map((item, idx) =>
          idx === editingPendingIndex ? formattedItem : item
        );
      }
      return [...previous, formattedItem];
    });

    resetComponentForm();
  };

  const handleUpdateExistingComponent = async () => {
    if (!editingComponentId) return;

    const validationErrors = {};

    if (!componentForm.componentId) {
      validationErrors.componentId = "Please select a salary component.";
    }

    const isZeroAmount = isAttendanceAllowance(componentForm.componentId) || isOtPay(componentForm.componentId);

    if (
      !isZeroAmount &&
      (componentForm.amount === "" || parseCurrency(componentForm.amount) < 0)
    ) {
      validationErrors.amount = "Please enter a valid amount.";
    }

    if (!componentForm.effectiveDate) {
      validationErrors.effectiveDate =
        "Please select the component effective start date.";
    }

    if (!componentForm.endDate) {
      validationErrors.endDate =
        "Please select the component effective end date.";
    }

    if (
      componentForm.effectiveDate &&
      componentForm.endDate &&
      new Date(componentForm.effectiveDate) > new Date(componentForm.endDate)
    ) {
      validationErrors.endDate =
        "Component end date cannot be before the effective date.";
    }

    if (Object.keys(validationErrors).length > 0) {
      setComponentErrors(validationErrors);
      return;
    }

    setSaving(true);

    try {
      await onSaveComponent(
        {
          employeeSalaryComponentId:
            componentForm.employeeSalaryComponentId ?? editingComponentId,
          employeeSalaryId: salary?.id,
          componentId: componentForm.componentId,
          componentAmount: isZeroAmount ? 0 : parseCurrency(componentForm.amount),
          componentPercentage: Number(componentForm.percentage || 0),
          effectiveDate: componentForm.effectiveDate,
          endDate: componentForm.endDate,
          isActive: componentForm.isActive !== false,
          remarks: componentForm.remarks ?? "",
        },
        true,
      );

      resetComponentForm();
    } catch (error) {
      console.error("Failed to update salary component: ", error);
    } finally {
      setSaving(false);
    }
  };

  const handleToggleExistingComponentStatus = async (
    component,
    newActiveState,
  ) => {
    const componentId = component.employeeSalaryComponentId ?? component.id;
    setSaving(true);

    const isZeroAmount = isAttendanceAllowance(component.componentId) || isOtPay(component.componentId);

    try {
      await onSaveComponent(
        {
          employeeSalaryComponentId: componentId,
          employeeSalaryId: salary?.id,
          componentId: component.componentId,
          componentAmount: isZeroAmount
            ? 0
            : parseCurrency(component.amount ?? component.componentAmount ?? 0),
          componentPercentage: Number(
            component.percentage ?? component.componentPercentage ?? 0,
          ),
          effectiveDate: component.effectiveDate,
          endDate: component.endDate,
          isActive: newActiveState,
          remarks: component.remarks ?? "",
        },
        true,
      );
    } catch (error) {
      console.error(
        `Failed to ${newActiveState ? "reactivate" : "remove"} salary component: `,
        error,
      );
    } finally {
      setSaving(false);
    }
  };

  // const handleRemovePendingComponent = (index) => {
  //   setPendingComponents((previous) => {
  //     const nextList = previous.filter((_, itemIndex) => itemIndex !== index);
  //     const hasPendingExtraDay = nextList.some((item) => isExtraDay(item.componentId));
  //     if (hasPendingExtraDay) {
  //       const recalculatedExtraDay = Number(computeExtraDayAmount(nextList));
  //       return nextList.map((item) =>
  //         isExtraDay(item.componentId)
  //           ? { ...item, amount: recalculatedExtraDay }
  //           : item,
  //       );
  //     }
  //     return nextList;
  //   });
  // };

  const handleRemovePendingComponent = (index) => {
    setPendingComponents((previous) =>
      previous.filter((_, itemIndex) => itemIndex !== index)
    );
  };

  /* ──────────────────────────────────────────────────────────────────────── */
  /* Main Save Handler                                                        */
  /* ──────────────────────────────────────────────────────────────────────── */

  const handleSave = async () => {
    if (isView) {
      onClose?.();
      return;
    }

    if (isEditingComponent) return;

    const validationErrors = {};

    if (!salaryForm.employeeId) {
      validationErrors.employeeId = "Please select an employee.";
    } else if (isAdd && isEmployeeAssigned(salaryForm.employeeId)) {
      validationErrors.employeeId =
        "This employee already has a salary assigned for this effective period.";
    }

    if (!salaryForm.dailyRate || parseInt(salaryForm.dailyRate, 10) < 0) {
      validationErrors.dailyRate =
        "Daily Rate is required and cannot be negative.";
    }

    const duplicateRef = employeeSalaries.some(
      (s) =>
        String(s.salaryReference ?? "")
          .trim()
          .toLowerCase() ===
          String(salaryForm.salaryReference ?? "")
            .trim()
            .toLowerCase() && !(isEdit && String(s.id) === String(salary?.id)),
    );

    if (duplicateRef) {
      validationErrors.salaryReference =
        "This salary reference is already in use.";
    }

    // if (salaryForm.payFrequency !== "W") {
    //   if (!salaryForm.basic) {
    //     validationErrors.basic = "Please enter a basic salary.";
    //   } else if (parseCurrency(salaryForm.basic) < 0) {
    //     validationErrors.basic = "Basic salary must be positive.";
    //   }
    // }

    // const basicAmount = salaryForm.payFrequency === "W" ? 0 : parseCurrency(salaryForm.basic);

    // if (salaryForm.payFrequency !== "W") {
    //   if (salaryForm.basic === "" || salaryForm.basic === null) {
    //     validationErrors.basic = "Please enter a basic salary.";
    //   } else if (basicAmount < 0) {
    //     validationErrors.basic = "Basic salary must be positive.";
    //   }
    // }

    const isBasicZeroed = isCategoryE || salaryForm.payFrequency === "W";
    const basicAmount = isBasicZeroed ? 0 : parseCurrency(salaryForm.basic);

    if (isCategoryC) {
      if (salaryForm.basic === "" || salaryForm.basic === null) {
        validationErrors.basic = "Please enter a basic salary.";
      } else if (basicAmount <= 0) {
        validationErrors.basic = "Basic salary must be greater than 0.";
      }
    } else if (!isBasicZeroed) {
      if (salaryForm.basic === "" || salaryForm.basic === null) {
        validationErrors.basic = "Please enter a basic salary.";
      } else if (basicAmount < 0) {
        validationErrors.basic = "Basic salary cannot be negative.";
      }
    }

    // If basic is 0, the employee must have an ATTEND-ALLOW component
    // if (basicAmount === 0) {
    //   const attendAllowComp = payrollComponents.find((c) => c.code?.toUpperCase() === "ATTEND-ALLOW");

    //   const attendAllowId = attendAllowComp ? String(attendAllowComp.id) : null;

    //   const hasExistingAttendAllow = currentSalaryComponents.some(
    //     (c) => String(c.componentId) === attendAllowId && c.isActive !== false
    //   );

    //   const hasPendingAttendAllow = pendingComponents.some(
    //     (c) => String(c.componentId) === attendAllowId
    //   );

    //   if (!hasExistingAttendAllow && !hasPendingAttendAllow) {
    //     validationErrors.basic = "An active Attendance Allowance is mandatory for weekly employees.";
    //   }
    // }

    // Attendance Allowance is mandatory only for Category "E" employees
    if (isCategoryE) {
      const attendAllowComp = payrollComponents.find((c) => c.code?.toUpperCase() === "ATTEND-ALLOW");

      const attendAllowId = attendAllowComp ? String(attendAllowComp.id) : null;

      const hasExistingAttendAllow = currentSalaryComponents.some(
        (c) => String(c.componentId) === attendAllowId && c.isActive !== false
      );

      const hasPendingAttendAllow = pendingComponents.some(
        (c) => String(c.componentId) === attendAllowId
      );

      if (!hasExistingAttendAllow && !hasPendingAttendAllow) {
        // Since the Basic input is hidden for Category "E", attach to dailyRate (or a toast) so it displays clearly
        validationErrors.dailyRate = "An active Attendance Allowance is mandatory for Daily Wage employees.";
      }
    }

    if (!salaryForm.effectiveDate) {
      validationErrors.effectiveDate = "Please select an effective start date.";
    }

    if (!salaryForm.endDate) {
      validationErrors.endDate = "Please select an effective end date.";
    }

    if (
      salaryForm.effectiveDate &&
      salaryForm.endDate &&
      new Date(salaryForm.effectiveDate) > new Date(salaryForm.endDate)
    ) {
      validationErrors.endDate = "End date cannot be before the starting date.";
    }

    if (salaryForm.workingDays !== "" && Number(salaryForm.workingDays) < 0) {
      validationErrors.workingDays = "Working days cannot be negative.";
    }

    if (
      salaryForm.dailyRate !== "" &&
      parseCurrency(salaryForm.dailyRate) < 0
    ) {
      validationErrors.dailyRate = "Daily rate cannot be negative.";
    }

    setErrors(validationErrors);

    if (Object.keys(validationErrors).length > 0) return;

    setSaving(true);

    try {
      const salaryPayload = {
        ...salaryForm,
        payFrequency: isCategoryC ? "M" : salaryForm.payFrequency,
        ...(isEdit && { id: salary?.id }),
        basic: isBasicZeroed ? 0 : parseCurrency(salaryForm.basic),
        grossSalary: Number(salaryForm.grossSalary || 0),
        workingDays:
          salaryForm.workingDays === ""
            ? undefined
            : Number(salaryForm.workingDays || 0),
        dailyRate:
          salaryForm.dailyRate === ""
            ? undefined
            : parseCurrency(salaryForm.dailyRate),
      };

      const sanitizedPendingComponents = pendingComponents.map((comp) => ({
        ...comp,
        amount: isAttendanceAllowance(comp.componentId) || isOtPay(comp.componentId) ? 0 : comp.amount,
      }));

      await onSave?.(salaryPayload, sanitizedPendingComponents);

      setPendingComponents([]);
      setComponentForm(INITIAL_COMPONENT_FORM);
      setShowComponentForm(false);
    } catch (error) {
      console.error("Failed to save employee salary:", error);
      toast.error("Failed to save employee salary.");
    } finally {
      setSaving(false);
    }
  };

  if (!open) return null;

  const title = isAdd
    ? "Assign Employee Salary"
    : isEdit
      ? "Update Employee Salary"
      : "Employee Salary Details";

  /* ──────────────────────────────────────────────────────────────────────── */
  /* Render                                                                   */
  /* ──────────────────────────────────────────────────────────────────────── */

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      {/* Backdrop */}
      <div
        className="fixed inset-0 bg-surface-900/40 backdrop-blur-xs transition-opacity"
        onClick={saving ? undefined : onClose}
      />

      {/* Modal Dialog Container */}
      {/* <div className="relative z-10 flex max-h-[92vh] w-full max-w-4xl flex-col rounded-2xl bg-white shadow-2xl overflow-hidden"> */}
      <div className="relative z-10 flex h-[88vh] max-h-[88vh] w-full max-w-4xl flex-col rounded-2xl bg-white shadow-2xl overflow-hidden">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5">
          <div>
            <h2 className="text-lg font-semibold text-surface-900">{title}</h2>
            {selectedEmployee && (
              <p className="mt-0.5 text-xs text-surface-500">
                {selectedEmployee.HED_SERVICE_NO} &bull; {selectedEmployee.HED_REPORT_NAME}
              </p>
            )}
          </div>
          <button
            type="button"
            onClick={saving ? undefined : onClose}
            className="rounded-full p-2 text-surface-400 hover:bg-surface-100 hover:text-surface-700 transition-colors"
          >
            <X size={18} />
          </button>
        </div>

        {/* Navigation Tabs */}
        <div className="px-8 border-b border-surface-100">
          <nav className="-mb-px flex space-x-7" aria-label="Tabs">
            <button
              type="button"
              onClick={() => setActiveTab(0)}
              className={`py-3 text-sm font-medium border-b-2 transition-all ${
                activeTab === 0
                  ? "border-primary-600 text-primary-600"
                  : "border-transparent text-surface-400 hover:text-surface-600"
              }`}
            >
              Salary Structure
            </button>
            <button
              type="button"
              disabled={!salaryForm.employeeId}
              onClick={() => setActiveTab(1)}
              className={`py-3 text-sm font-medium border-b-2 transition-all ${
                activeTab === 1
                  ? "border-primary-600 text-primary-600"
                  : "border-transparent text-surface-400 hover:text-surface-600"
              } disabled:opacity-40 disabled:cursor-not-allowed`}
            >
              Overtime Rate
            </button>
            <button
              type="button"
              disabled={!salaryForm.employeeId}
              onClick={() => setActiveTab(2)}
              className={`inline-flex items-center gap-2 py-3 text-sm font-medium border-b-2 transition-all ${
                activeTab === 2
                  ? "border-primary-600 text-primary-600"
                  : "border-transparent text-surface-400 hover:text-surface-600"
              } disabled:opacity-40 disabled:cursor-not-allowed`}
            >
              <span>Previous Salaries</span>
              <span className="inline-flex h-4 min-w-[16px] items-center justify-center rounded-full bg-amber-500 px-1 text-[10px] font-bold text-white shadow-xs">
                {previousSalaries.length}
              </span>
            </button>
          </nav>
        </div>

        {/* Content Body */}
        <div className="flex-1 overflow-y-auto px-8 py-6">
          {/* TAB 0: Salary Structure */}
          {activeTab === 0 && (
            <div className="space-y-8">
              <section>
                <div className="mb-6">
                  <h3 className={SECTION_TITLE_CLASS}>
                    Employee Salary Details
                  </h3>
                  <p className={SECTION_SUBTITLE_CLASS}>
                    Configure the employee's salary and effective period.
                  </p>
                </div>

                <div className="grid grid-cols-1 gap-5 sm:grid-cols-2">
                  {/* <SelectInput
                    label="Employee"
                    value={salaryForm.employeeId}
                    disabled={!isAdd || isView}
                    error={errors.employeeId}
                    onChange={(event) =>
                      handleSalaryChange("employeeId", event.target.value)
                    }
                  >
                    <option value="">Select Employee</option>
                    {employees.map((employee) => (
                      <option
                        key={employee.HED_EMPLOYEE_ID}
                        value={employee.HED_EMPLOYEE_ID}
                      >
                        {employee.HED_SERVICE_NO} - {employee.HED_REPORT_NAME}
                      </option>
                    ))}
                  </SelectInput> */}

                  <Field label="Employee" error={errors.employeeId}>
                    <SearchableSelect
                      value={salaryForm.employeeId}
                      onChange={(val) => handleSalaryChange("employeeId", val)}
                      options={employees.map((emp) => ({
                        value: emp.HED_EMPLOYEE_ID,
                        label: `${emp.HED_SERVICE_NO} - ${emp.HED_REPORT_NAME}`,
                        searchText: `${emp.HED_SERVICE_NO} ${emp.HED_REPORT_NAME}`,
                      }))}
                      disabled={!isAdd || isView}
                      placeholder="Select Employee"
                      searchPlaceholder="Search by service no or name..."
                      className={`${INPUT_CLASS} ${
                        !isAdd || isView ? DISABLED_INPUT_CLASS : "cursor-pointer"
                      } ${
                        errors.employeeId
                          ? "border-red-400 focus:border-red-500 focus:ring-red-500/10"
                          : ""
                      }`}
                    />
                  </Field>

                  <SelectInput
                    label="Pay Frequency"
                    value={isCategoryC ? "M" : salaryForm.payFrequency}
                    error={errors.payFrequency}
                    disabled={isView || isCategoryC}
                    onChange={(event) =>
                      handleSalaryChange("payFrequency", event.target.value)
                    }
                  >
                    {PAY_FREQUENCIES.map((frequency) => (
                      <option key={frequency.value} value={frequency.value}>
                        {frequency.label}
                      </option>
                    ))}
                  </SelectInput>

                  {!isCategoryE && (
                    <CurrencyInput
                      label="Basic Salary"
                      value={salaryForm.basic}
                      error={errors.basic}
                      disabled={isView || salaryForm.payFrequency === "W"}
                      onChange={(value) => handleSalaryChange("basic", value)}
                    />
                  )}

                  <TextInput
                    label="Salary Reference"
                    value={salaryForm.salaryReference}
                    error={errors.salaryReference}
                    disabled
                    onChange={(event) =>
                      handleSalaryChange("salaryReference", event.target.value)
                    }
                  />

                  <DateInput
                    label="Effective Start Date"
                    value={salaryForm.effectiveDate}
                    error={errors.effectiveDate}
                    disabled={isView}
                    onChange={(value) =>
                      handleSalaryChange("effectiveDate", value)
                    }
                  />

                  <DateInput
                    label="Effective End Date"
                    value={salaryForm.endDate}
                    error={errors.endDate}
                    disabled={isView}
                    onChange={(value) => handleSalaryChange("endDate", value)}
                  />

                  <CurrencyInput
                    label="Daily Rate"
                    value={salaryForm.dailyRate}
                    error={errors.dailyRate}
                    disabled={isView}
                    onChange={(value) => handleSalaryChange("dailyRate", value)}
                  />

                  <TextArea
                    label="Remarks"
                    value={salaryForm.remarks}
                    error={errors.remarks}
                    disabled={isView}
                    rows={1}
                    onChange={(event) =>
                      handleSalaryChange("remarks", event.target.value)
                    }
                  />
                </div>
              </section>

              {/* Salary Components Section */}
              <section className="pt-2">
                <div className="mb-4 flex items-center justify-between gap-3">
                  <div>
                    <h3 className={SECTION_TITLE_CLASS}>Salary Components</h3>
                    <p className={SECTION_SUBTITLE_CLASS}>
                      Add allowances, deductions, and other recurring components.
                    </p>
                  </div>

                  {!isView && (
                    <button
                      type="button"
                      onClick={() =>
                        setShowComponentForm((previous) => {
                          const opening = !previous;
                          if (opening && !editingComponentId) {
                            const today = new Date();
                            setEditingPendingIndex(null);
                            setComponentForm({
                              ...INITIAL_COMPONENT_FORM,
                              effectiveDate: toIsoDate(today),
                              endDate: toIsoDate(getLastDayOfThisMonth(today)),
                            });
                          }
                          return opening;
                        })
                      }
                      className="inline-flex items-center gap-1.5 rounded-lg border border-primary-600/30 bg-primary-50/50 px-3 py-1.5 text-xs font-semibold text-primary-700 transition-colors hover:bg-primary-100/60"
                    >
                      <Plus size={14} />
                      Add Component
                    </button>
                  )}
                </div>

                {/* Sub-form */}
                {showComponentForm && !isView && (
                  <div className="mb-6 rounded-xl bg-surface-50/80 p-5 ring-1 ring-surface-200/70">
                    <div className="mb-4 flex items-center justify-between">
                      <div>
                        <h4 className="text-xs font-semibold text-surface-800">
                          {editingComponentId || editingPendingIndex !== null
                            ? "Edit Salary Component"
                            : "New Salary Component"}
                        </h4>
                        <p className="text-[11px] text-surface-500">
                          {editingComponentId
                            ? "Update the component details."
                            : "Add component allocation details."}
                        </p>
                      </div>
                      <button
                        type="button"
                        onClick={resetComponentForm}
                        className="rounded-full p-1 text-surface-400 hover:bg-surface-200/50 hover:text-surface-700"
                        title="Close"
                      >
                        <X size={14} />
                      </button>
                    </div>

                    <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                      {/* <SelectInput
                        label="Salary Component"
                        value={componentForm.componentId}
                        error={componentErrors.componentId}
                        onChange={(event) => {
                          const selectedId = event.target.value;
                          handleComponentChange("componentId", selectedId);
                          if (selectedId) {
                            const selectedComp = payrollComponents.find(
                              (c) => String(c.id) === String(selectedId),
                            );
                            const code = selectedComp?.code?.toUpperCase();

                            if (code === "ATTEND-ALLOW") {
                              handleComponentChange("amount", salaryForm.dailyRate || "");
                            } 
                            else if (code === "OT-PAY") {
                              const otRate = selectedEmployee?.HED_OT_RATE;
                              const formattedOt = otRate != null ? maskCurrencyInput(Number(otRate).toFixed(2)) : "";
                              handleComponentChange("amount", formattedOt);
                            }
                            else if (code === "EXTRA-DAY") {
                              const extraDayVal = computeExtraDayAmount();
                              handleComponentChange("amount", maskCurrencyInput(extraDayVal));
                            }
                            else if (
                              selectedComp &&
                              (selectedComp.defaultAmount > 0 || Number(selectedComp.HPC_DEFAULT_AMOUNT) > 0)
                            ) {
                              const defaultAmt = selectedComp.defaultAmount || selectedComp.HPC_DEFAULT_AMOUNT;
                              const formattedDefault = maskCurrencyInput(
                                Number(defaultAmt).toFixed(2),
                              );
                              handleComponentChange("amount", formattedDefault);
                            } else {
                              handleComponentChange("amount", "");
                            }
                          } else {
                            handleComponentChange("amount", "");
                          }
                        }}
                      >
                        <option value="">Select Salary Component</option>
                        {payrollComponents
                          .filter(
                            (component) =>
                              !component.basic && component.type === "Earning",
                          )
                          .map((component) => (
                            <option key={component.id} value={component.id}>
                              {component.name}
                            </option>
                          ))}
                      </SelectInput> */}

                      <Field label="Salary Component" error={componentErrors.componentId}>
                        <SearchableSelect
                          value={componentForm.componentId}
                          onChange={(selectedId) => {
                            handleComponentChange("componentId", selectedId);

                            if (selectedId) {
                              const selectedComp = payrollComponents.find(
                                (c) => String(c.id) === String(selectedId)
                              );
                              const code = selectedComp?.code?.toUpperCase();

                              if (code === "ATTEND-ALLOW") {
                                handleComponentChange("amount", salaryForm.dailyRate || "");
                              } else if (code === "OT-PAY") {
                                const otRate = selectedEmployee?.HED_OT_RATE;
                                const formattedOt =
                                  otRate != null ? maskCurrencyInput(Number(otRate).toFixed(2)) : "";
                                handleComponentChange("amount", formattedOt);
                              } else if (code === "EXTRA-DAY") {
                                const extraDayVal = computeExtraDayAmount();
                                handleComponentChange("amount", maskCurrencyInput(extraDayVal));
                              } else if (
                                selectedComp &&
                                (selectedComp.defaultAmount > 0 ||
                                  Number(selectedComp.HPC_DEFAULT_AMOUNT) > 0)
                              ) {
                                const defaultAmt =
                                  selectedComp.defaultAmount || selectedComp.HPC_DEFAULT_AMOUNT;
                                const formattedDefault = maskCurrencyInput(
                                  Number(defaultAmt).toFixed(2)
                                );
                                handleComponentChange("amount", formattedDefault);
                              } else {
                                handleComponentChange("amount", "");
                              }
                            } else {
                              handleComponentChange("amount", "");
                            }
                          }}
                          options={payrollComponents
                            .filter((component) => !component.basic && component.type === "Earning")
                            .map((component) => ({
                              value: component.id,
                              label: component.name,
                              searchText: `${component.code || ""} ${component.name || ""}`,
                            }))}
                          disabled={isView}
                          placeholder="Select Salary Component"
                          searchPlaceholder="Search components..."
                          className={`${INPUT_CLASS} ${
                            isView ? DISABLED_INPUT_CLASS : "cursor-pointer"
                          } ${
                            componentErrors.componentId
                              ? "border-red-400 focus:border-red-500 focus:ring-red-500/10"
                              : ""
                          }`}
                        />
                      </Field>

                      <CurrencyInput
                        label="Amount"
                        value={componentForm.amount}
                        error={componentErrors.amount}
                        disabled={isView || isAmountLocked}
                        onChange={(value) =>
                          handleComponentChange("amount", value)
                        }
                      />

                      <DateInput
                        label="Effective Start Date"
                        value={componentForm.effectiveDate}
                        error={componentErrors.effectiveDate}
                        onChange={(value) =>
                          handleComponentChange("effectiveDate", value)
                        }
                      />

                      <DateInput
                        label="Effective End Date"
                        value={componentForm.endDate}
                        error={componentErrors.endDate}
                        onChange={(value) =>
                          handleComponentChange("endDate", value)
                        }
                      />

                      <TextArea
                        label="Remarks"
                        value={componentForm.remarks}
                        rows={1}
                        className="sm:col-span-2"
                        onChange={(event) =>
                          handleComponentChange("remarks", event.target.value)
                        }
                      />
                    </div>

                    <div className="mt-5 flex justify-end gap-2">
                      <button
                        type="button"
                        onClick={resetComponentForm}
                        className="rounded-lg px-3 py-1.5 text-xs font-medium text-surface-600 hover:bg-surface-200/50"
                      >
                        Cancel
                      </button>
                      <button
                        type="button"
                        onClick={
                          editingComponentId
                            ? handleUpdateExistingComponent
                            : handleAddPendingComponent
                        }
                        disabled={saving}
                        className="inline-flex items-center gap-1.5 rounded-lg bg-primary-600 px-4 py-1.5 text-xs font-medium text-white shadow-xs hover:bg-primary-700 disabled:opacity-50"
                      >
                        {!(
                          editingComponentId || editingPendingIndex !== null
                        ) && <Plus size={13} />}
                        {editingComponentId || editingPendingIndex !== null
                          ? "Update Component"
                          : "Add Component"}
                      </button>
                    </div>
                  </div>
                )}

                {/* Components Table / Empty State */}
                {currentSalaryComponents.length === 0 &&
                pendingComponents.length === 0 ? (
                  <div className="py-8 text-center">
                    <p className="text-xs text-surface-400">
                      No salary components assigned.
                    </p>
                  </div>
                ) : (
                  <div className="overflow-x-auto">
                    <table className="w-full min-w-[620px] text-xs">
                      <thead>
                        <tr className="border-b border-surface-100 text-surface-400">
                          <th className="pb-3 text-left font-medium">Component</th>
                          <th className="pb-3 text-right font-medium">Amount</th>
                          <th className="pb-3 text-center font-medium">Effective</th>
                          <th className="pb-3 text-center font-medium">End</th>
                          <th className="pb-3 text-center font-medium">Status</th>
                          {!isView && (
                            <th className="w-20 pb-3 text-center font-medium">Actions</th>
                          )}
                        </tr>
                      </thead>

                      <tbody className="divide-y divide-surface-100/60">
                        {currentSalaryComponents.map((component) => {
                          const isAttendAllow = isAttendanceAllowance(component.componentId);
                          const isOt = isOtPay(component.componentId)
                          // const displayAmount = isAttendAllow 
                          //   ? (parseCurrency(salaryForm.dailyRate) || salary?.dailyRate || 0) 
                          //   : isOt
                          //     ? (Number(selectedEmployee?.HED_OT_RATE) || 0)
                          //     : component.amount;
                          const displayAmount = isAttendAllow 
                            ? (parseCurrency(salaryForm.dailyRate) || salary?.dailyRate || 0) 
                            : isOt
                              ? (Number(selectedEmployee?.HED_OT_RATE) || 0)
                              : (component.amount ?? component.componentAmount ?? 0);
                          
                          return (
                            <tr
                              key={`saved-${component.id}`}
                              className="group hover:bg-surface-50/50 transition-colors"
                            >
                              <td className="py-3 font-medium text-surface-800">
                                {component.componentName}
                              </td>
                              <td className="py-3 text-right tabular-nums text-surface-700">
                                {fmtMoney(displayAmount)}
                              </td>
                              <td className="py-3 text-center tabular-nums text-surface-500">
                                {toIsoDate(component.effectiveDate)}
                              </td>
                              <td className="py-3 text-center tabular-nums text-surface-500">
                                {toIsoDate(component.endDate)}
                              </td>
                              <td className="py-3 text-center">
                                <StatusPill
                                  label={
                                    component.isActive ? "Active" : "Inactive"
                                  }
                                />
                              </td>
                              {!isView && (
                                <td className="py-3 text-center">
                                  <div className="flex items-center justify-center gap-1 opacity-80 group-hover:opacity-100">
                                    <button
                                      type="button"
                                      onClick={() =>
                                        handleEditExistingComponent(component)
                                      }
                                      disabled={saving}
                                      className="rounded p-1 text-surface-400 hover:bg-surface-100 hover:text-primary-600 disabled:opacity-50"
                                      title="Edit component"
                                    >
                                      <Pencil size={13} />
                                    </button>
                                    {component.isActive !== false ? (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleToggleExistingComponentStatus(
                                            component,
                                            false,
                                          )
                                        }
                                        disabled={saving}
                                        className="rounded p-1 text-surface-400 hover:bg-red-50 hover:text-red-500 disabled:opacity-50"
                                        title="Deactivate component"
                                      >
                                        <Trash2 size={13} />
                                      </button>
                                    ) : (
                                      <button
                                        type="button"
                                        onClick={() =>
                                          handleToggleExistingComponentStatus(
                                            component,
                                            true,
                                          )
                                        }
                                        disabled={saving}
                                        className="rounded p-1 text-surface-400 hover:bg-emerald-50 hover:text-emerald-600 disabled:opacity-50"
                                        title="Reactivate component"
                                      >
                                        <RotateCcw size={13} />
                                      </button>
                                    )}
                                  </div>
                                </td>
                              )}
                            </tr>
                        )})}

                        {pendingComponents.map((component, index) => {
                          const componentName =
                            payrollComponents.find(
                              (item) =>
                                String(item.id) ===
                                String(component.componentId),
                            )?.name ?? "-";

                            const isAttendAllow = isAttendanceAllowance(component.componentId);
                            const isOt = isOtPay(component.componentId);
                            // const displayAmount = isAttendAllow 
                            //   ? (parseCurrency(salaryForm.dailyRate) || 0) 
                            //   : isOt
                            //     ? (Number(selectedEmployee?.HED_OT_RATE) || 0)
                            //     : component.amount;
                            const displayAmount = isAttendAllow 
                              ? (parseCurrency(salaryForm.dailyRate) || 0) 
                              : isOt
                                ? (Number(selectedEmployee?.HED_OT_RATE) || 0)
                                : component.amount;

                          return (
                            <tr
                              key={`pending-${index}`}
                              className="group bg-primary-50/20"
                            >
                              <td className="py-3 font-medium text-surface-800">
                                {componentName}
                                <span className="ml-2 rounded-full bg-primary-100/70 px-2 py-0.5 text-[9px] font-semibold text-primary-700">
                                  New
                                </span>
                              </td>
                              <td className="py-3 text-right tabular-nums text-surface-700">
                                {fmtMoney(displayAmount)}
                              </td>
                              <td className="py-3 text-center tabular-nums text-surface-500">
                                {toIsoDate(component.effectiveDate)}
                              </td>
                              <td className="py-3 text-center tabular-nums text-surface-500">
                                {toIsoDate(component.endDate)}
                              </td>
                              <td className="py-3 text-center">
                                <StatusPill label="Active" />
                              </td>
                              <td className="py-3 text-center">
                                <div className="flex items-center justify-center gap-1 opacity-80 group-hover:opacity-100">
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleEditPendingComponent(index)
                                    }
                                    disabled={saving}
                                    className="rounded p-1 text-surface-400 hover:bg-surface-100 hover:text-primary-600 disabled:opacity-50"
                                    title="Edit component"
                                  >
                                    <Pencil size={13} />
                                  </button>
                                  <button
                                    type="button"
                                    onClick={() =>
                                      handleRemovePendingComponent(index)
                                    }
                                    className="rounded p-1 text-surface-400 hover:bg-red-50 hover:text-red-500"
                                    title="Remove"
                                  >
                                    <Trash2 size={13} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                )}
              </section>
            </div>
          )}

          {/* TAB 1: Overtime Rate */}
          {activeTab === 1 && (
            <div>
              <div className="mb-6">
                <h3 className={SECTION_TITLE_CLASS}>Overtime History</h3>
                <p className={SECTION_SUBTITLE_CLASS}>
                  Current and past overtime rates for{" "}
                  {selectedEmployee?.HED_REPORT_NAME}.
                </p>
              </div>

              {otRateHistoryLoading ? (
                <div className="flex h-36 items-center justify-center">
                  <div className="h-6 w-6 animate-spin rounded-full border-2 border-primary-200 border-t-primary-600" />
                </div>
              ) : otRateHistory.length === 0 ? (
                <div className="py-12 text-center text-sm text-surface-400">
                  No overtime history found for this employee.
                </div>
              ) : (
                <div className="overflow-x-auto">
                  <table className="w-full text-xs">
                    <thead>
                      <tr className="border-b border-surface-100 text-surface-400">
                        <th className="pb-3 text-left font-medium">Rate</th>
                        <th className="pb-3 text-left font-medium">Status</th>
                        <th className="pb-3 text-left font-medium">Effective Date</th>
                        <th className="pb-3 text-left font-medium">End Date</th>
                        <th className="pb-3 text-left font-medium">Remarks</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-surface-100/60">
                      {otRateHistory.map((ot) => (
                        <tr
                          key={ot.HEO_ID}
                          className={`${
                            ot.HEO_IS_CURRENT === "True" ? "bg-primary-50/30" : ""
                          }`}
                        >
                          <td className="py-3 font-semibold text-surface-800">
                            {fmtMoney(ot.HEO_OT_RATE)}
                          </td>
                          <td className="py-3">
                            <StatusPill label={ot.RATE_STATUS} />
                          </td>
                          <td className="py-3 text-surface-500">
                            {toIsoDate(ot.HEO_EFFECTIVE_DATE)}
                          </td>
                          <td className="py-3 text-surface-500">
                            {ot.HEO_END_DATE ? toIsoDate(ot.HEO_END_DATE) : "-"}
                          </td>
                          <td
                            className="max-w-xs truncate py-3 text-surface-500"
                            title={ot.HEO_REMARKS}
                          >
                            {ot.HEO_REMARKS || "-"}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          )}

          {/* TAB 2: Previous Salaries (Redesigned) */}
          {activeTab === 2 && (
            <div>
              <div className="mb-6">
                <h3 className={SECTION_TITLE_CLASS}>Previous Salary Records</h3>
                <p className={SECTION_SUBTITLE_CLASS}>
                  Historical salary records and breakdown for{" "}
                  {selectedEmployee?.HED_REPORT_NAME}.
                </p>
              </div>

              {previousSalaries.length === 0 ? (
                <div className="py-12 text-center text-sm text-surface-400">
                  No previous salary records exist.
                </div>
              ) : (
                <div className="space-y-4">
                  {previousSalaries.map((prevSalary) => {
                    const assignedComponents = salaryComponents.filter(
                      (comp) => {
                        if (
                          String(comp.employeeSalaryId) !==
                          String(prevSalary.id)
                        ) {
                          return false;
                        }
                        const pc = payrollComponents.find(
                          (c) => String(c.id) === String(comp.componentId),
                        );
                        return pc && !pc.basic && pc.type === "Earning";
                      },
                    );

                    return (
                      <div
  key={prevSalary.id}
  className="relative flex flex-col md:flex-row md:items-center justify-between gap-6 rounded-2xl bg-surface-50/50 p-6 transition-colors hover:bg-surface-50 border border-gray-300"
>
  {/* Left: Era Context & Meta */}
  <div className="flex flex-col gap-1.5 md:max-w-xs">
    <div className="flex items-center gap-2">
      <span className="text-sm font-semibold text-surface-900">
        {prevSalary.effectiveDate
          ? toIsoDate(prevSalary.effectiveDate)
          : "N/A"}{" "}
        &mdash;{" "}
        {prevSalary.endDate ? toIsoDate(prevSalary.endDate) : "Present"}
      </span>
      <span className="rounded-md bg-surface-200/60 px-1.5 py-0.5 text-[10px] font-semibold text-surface-600 uppercase tracking-wide">
        {prevSalary.payFrequency === "W" ? "Weekly" : "Monthly"}
      </span>
    </div>

    <span className="font-mono text-[11px] text-surface-400">
      Ref: {prevSalary.salaryReference || "Unreferenced"}
    </span>

    {/* Allowances Breakdown (Additive badges) */}
    {assignedComponents.length > 0 && (
      <div className="mt-2 flex flex-wrap gap-1.5">
        {assignedComponents.map((comp) => {
          const compDetails = payrollComponents.find(
            (c) => String(c.id) === String(comp.componentId)
          );

          const isAttendAllow = compDetails?.code?.toUpperCase() === "ATTEND-ALLOW";
          const isOt = compDetails?.code?.toUpperCase() === "OT-PAY";
          // const displayAmount = isAttendAllow 
          //   ? (prevSalary.dailyRate || 0) 
          //   : isOt 
          //     ? (Number(selectedEmployee?.HED_OT_RATE) || 0)
          //     : comp.amount;
          const displayAmount = isAttendAllow 
          ? (prevSalary.dailyRate || 0) 
          : isOt 
            ? (Number(selectedEmployee?.HED_OT_RATE) || 0)
            : (comp.amount ?? comp.componentAmount ?? 0);

          return (
            <span
              key={comp.id}
              className="inline-flex items-center gap-1 rounded-md bg-white px-2 py-0.5 text-[11px] text-surface-600 shadow-2xs"
            >
              <span>{compDetails?.name || `Component ${comp.componentId}`}</span>
              <span className="font-semibold text-surface-800">
                +{fmtMoney(displayAmount)}
              </span>
            </span>
          );
        })}
      </div>
    )}
  </div>

  {/* Right: Key Figures in clean alignment without boxes */}
  <div className="flex items-baseline gap-8 self-start md:self-center">
    <div>
      <span className="block text-[11px] font-medium uppercase tracking-wider text-surface-400">
        Basic Pay
      </span>
      <span className="text-xl font-bold tracking-tight text-surface-900 tabular-nums">
        {fmtMoney(prevSalary.basic)}
      </span>
    </div>

    <div className="text-right">
      <span className="block text-[11px] font-medium uppercase tracking-wider text-surface-400">
        Daily Rate
      </span>
      <span className="text-sm font-semibold text-surface-600 tabular-nums">
        {fmtMoney(prevSalary.dailyRate || 0)}
      </span>
    </div>
  </div>
</div>
                    );
                  })}
                </div>
              )}
            </div>
          )}
        </div>

        {/* Footer Actions */}
        <div className="flex items-center justify-end gap-3 px-8 py-4 bg-surface-50/50">
          <button
            type="button"
            onClick={onClose}
            disabled={saving}
            className="rounded-lg px-4 py-2 text-sm font-medium text-surface-600 hover:bg-surface-100 hover:text-surface-800 transition-colors disabled:opacity-50"
          >
            {isView ? "Close" : "Cancel"}
          </button>

          {!isView && activeTab === 0 && (
            <button
              type="button"
              onClick={handleSave}
              disabled={saving || isEditingComponent}
              className="inline-flex items-center gap-2 rounded-lg bg-primary-600 px-5 py-2 text-sm font-medium text-white shadow-xs hover:bg-primary-700 active:bg-primary-800 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {saving && <Loader2 size={16} className="animate-spin" />}
              {saving ? "Saving..." : isEdit ? "Update" : "Save"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default EmployeeSalaryDialog;